import { css } from '@emotion/react';

import { colors } from 'src/styles/colors';
import { MediaBP as MQ } from 'src/styles/mediaQuery';
import {
  CommerceIconsSet,
  OtherIconsSet
} from 'src/utils/constants/IconsConstants';

import {
  IconsConstants,
  SetFontSize,
  ZeeFontBold,
  ZeeFontMedium,
  ZeeFontRegular,
  getCommerceIcons,
  getOtherIcons
} from '../../../styles/font';
import {
  notasansRegular,
  notasansMedium,
  zee5PlayerIcons
} from '../../../fonts/customFontsConfig';
export const playerWrapper = css`
  flex-basis: 63%;
  .figureTeaserBannerWrapper {
    z-index: 2;
  }
  .figureTeaserBannerWrapper .teaserWrapperAdded {
    margin-bottom: 48px;
  }
  #video-tag-tobaccoAdvisory {
    width: 100%;
    max-height: 100%;
    height: 100%;
    position: absolute;
  }
  .playerPlaceholderAr {
    position: relative;
    z-index: 2;
  }
  .playerPlaceholderAr:before {
    display: block;
    content: ' ';
    width: 100%;
    padding-top: 56.25%;
  }
  .playerPlaceholderAr > .content {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  @media screen and (max-width: 1199px) and (orientation: portrait) {
    .playerPlaceholderAr.teaserHeight {
      margin-bottom: 48px;
    }
    .playerPlaceholderAr .playerContentWrapper {
      position: fixed;
      top: 65px;
      bottom: auto;
    }
  }
  @media screen and (max-width: 599px) and (orientation: portrait) {
    .playerPlaceholderAr .playerContentWrapper {
      top: 44px;
    }
  }
  ${MQ.MediaLg} {
    .playerPlaceholderAr.teaserHeight {
      margin-bottom: 65px;
    }
  }

  /* Top banner */
  @media screen and (max-width: 1199px) and (orientation: portrait) {
    #af-smart-banner ~ #root .playerPlaceholderAr .playerContentWrapper {
      top: 135px;
    }
  }
  @media screen and (max-width: 599px) and (orientation: portrait) {
    #af-smart-banner ~ #root .playerPlaceholderAr .playerContentWrapper {
      top: 114px;
    }
  }

  /* Player component will start here */
  .playerContainer {
    position: relative;
  }
  .playerContainer {
    .up-next-carousel {
      overflow: hidden;
      bottom: 62px;
      height: 48px;
      display: flex;
      position: absolute;
      align-items: flex-end;
      margin-left: 10px;
      width: calc(100% - 10px);
      @media #{$MediaScreenLgMax} {
        overflow: auto;
      }
      .carousel-item-slide {
        // flex-shrink: 0;
        // height: 100%;
        border-radius: 8px;
        height: 46px;
        margin-right: 6px;
        background-color: rgba(0, 0, 0, 0.6);
        border: 1px solid rgba(255, 255, 255, 0.31);
        .mainCarouselDiv {
          width: 190px;
          height: 100%;
          box-sizing: border-box;
          padding: 5px;
          cursor: pointer;
          img {
            border-radius: 6px;
            height: 100%;
            width: auto;
            margin-right: 5px;
            float: left;
          }
        }
        .metadataContainer {
          display: flex;
          justify-content: center;
          flex-direction: column;
          margin-left: 10px;
          height: 100%;
          .upNext {
            ${ZeeFontBold(10, 14)};
            color: ${colors.PlayerRose};
          }
          .upNextTitle {
            ${ZeeFontMedium(8, 8)};
            color: ${colors.PrimaryWhiteColor};
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .upNextStart {
            ${ZeeFontMedium(8, 12)};
            color: ${colors.PrimaryWhiteColor};
            .second-color {
              color: ${colors.PlayerRose};
            }
          }
        }
      }
      ${MQ.MediaSm} {
        height: 82px;
        bottom: 68px;
        .carousel-item-slide {
          height: 80px;
          .mainCarouselDiv {
            width: 300px;
            padding: 8px;
            img {
              margin-right: 16px;
            }
          }
          .metadataContainer {
            .upNext,
            .upNextTitle,
            .upNextStart {
              font-size: 1rem;
              line-height: 1.3rem;
            }
          }
        }
      }

      ${MQ.MediaMd} {
        bottom: 72px;
      }

      ${MQ.MediaLg} {
        height: 90px;
        bottom: 85px;
        .carousel-item-slide {
          height: 88px;
          .mainCarouselDiv {
            width: 360px;
            padding: 10px;
            img {
              margin-right: 16px;
            }
          }
          .metadataContainer {
            .upNext {
              font-size: 1.5rem;
              line-height: 2rem;
            }
            .upNextTitle,
            .upNextStart {
              font-size: 1.2rem;
              line-height: 1rem;
            }
          }
        }
      }
      ${MQ.MediaLgCommon} {
        height: 108px;
        .carousel-item-slide {
          height: 106px;
          .metadataContainer {
            .upNextTitle,
            .upNextStart {
              margin-top: 6px;
            }
          }
        }
      }
    }
    .carousal-button-container {
      display: none;
      pointer-events: none;
      ${MQ.MediaLg} {
        display: block;
        position: absolute;
        bottom: 85px;
        left: 10px;
        right: 0;
        height: 89px;
        .carousal-prev-button,
        .carousal-next-button {
          position: absolute;
          left: 8px;
          top: 50%;
          transform: translateY(-50%);
          pointer-events: all;
          cursor: pointer;
        }
        .carousal-next-button {
          left: auto;
          right: 8px;
        }
      }
      ${MQ.MediaLgCommon} {
        height: 108px;
      }
    }
  }
  .playerContainer:before {
    display: block;
    content: ' ';
    width: 100%;
    padding-top: 56.25%;
  }
  .playerContainer > .content {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  .playerContainer:before {
    background-size: auto 50%;
    background-image: url('/webapp-assets/images/placeholder_zee5.svg');
    background-repeat: no-repeat;
    background-position: center;
    background-color: rgb(26, 12, 39);
  }
  .playerContainer > .content {
    width: 100%;
    height: 100%;
  }
  .playerContainer video.playerComp {
    display: none;
  }

  .chromeCastBtnContainer {
    margin-top: 10px;
    right: 2%;
    background: transparent;
    cursor: pointer;
    z-index: 1;
    height: 24px;
    width: 30px;
    &.adjustChromeCastIconContainer {
      margin-right: 38%;
    }
  }

  .audio-selection-wrapper {
    position: absolute;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    flex-direction: column;
    height: 100%;
    background: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.8) 100%
    );
    transform: matrix(1, 0, 0, 1, 0, 0);
    top: 0%;
  }

  .audio-selection-list {
    display: flex;
    flex-direction: row;
  }

  .audio-stream-item {
    ${ZeeFontBold(12, 13.333333333)}
    cursor: pointer;
    padding: 10px 12px 6px;
    width: 75px;
    height: 36px;
    color: #ffffff;
    font-weight: 500;
    background: rgba(255, 255, 255, 0.15);
    border: 1px solid #ffffff;
    border-radius: 99px;
    margin-right: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row-reverse;
  }
  ${MQ.MediaSm} {
    .audio-stream-item {
      ${ZeeFontBold(14, 14.285714286)}
      font-weight: 500;
      width: 120px;
      height: 38px;
    }
  }
  ${MQ.MediaMd} {
    .audio-stream-item {
      ${ZeeFontBold(14, 14.285714286)}
      font-weight: 500;
      width: 120px;
      height: 38px;
    }
  }
  ${MQ.MediaXl} {
    .audio-stream-item {
      ${ZeeFontBold(18, 14.444444444)}
      font-weight: 500;
      width: 120px;
      height: 38px;
    }
  }

  .audio-selection-title {
    ${ZeeFontBold(14, 14.285714286)}
    margin-top: 21px;
    text-align: center;
    color: #ffffff;
    margin-bottom: 12px;
  }
  ${MQ.MediaSm} {
    .audio-selection-title {
      ${ZeeFontBold(16, 13.75)}
      margin-top: 28px;
    }
  }
  ${MQ.MediaMd} {
    .audio-selection-title {
      ${ZeeFontBold(18, 13.3333333)}
      margin-top: 32px;
    }
  }
  ${MQ.MediaXl} {
    .audio-selection-title {
      ${ZeeFontBold(28, 15)}
      margin-top: 32px;
    }
  }

  .activeAudioLang {
    font-weight: 700;
    padding: 8px 16px;
  }
  .activeAudioLang > span {
    margin-right: 9px;
  }

  .vjs-menu li {
    text-transform: none;
  }

  /* All the spcific section scss file will add here */
  .playerContainer {
  }
  .playerContainer video::-webkit-media-text-track-container {
    display: none;
  }
  .playerContainer #video-tag-popup .vjs-http-source-selector,
  .playerContainer #video-tag-popup .vjs-fullscreen-control,
  .playerContainer #video-tag-popup .vjs-volume-control,
  .playerContainer #video-tag-popup .vjs-audio-button,
  .playerContainer #video-tag-popup .vjs-subtitles-button {
    display: none;
  }
  .playerContainer #video-tag-popup .vjs-volume-panel.vjs-hover {
    transition: none;
    width: 40px;
  }
  ${MQ.MediaXl} {
    .playerContainer #video-tag-popup .vjs-volume-panel.vjs-hover {
      width: 46px;
    }
  }
  .playerContainer #ad-ui {
    width: 100%;
    height: 100%;
  }
  .playerContainer #ins_endcard {
    text-decoration: none;
    display: block;
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0;
    bottom: 0;
    z-index: 99;
  }
  .playerContainer .info-container {
    height: auto;
    width: auto;
    position: absolute;
    color: #ffffff;
    top: 8px;
    left: 8px;
    padding-left: 8px;
    border-left: 4px solid #8230c6;
    margin-right: 6px;
    font-style: normal;
    animation: 0.5s ease-in-out 0s 1 fadeIn;
  }
  @media (min-width: 600px) {
    .playerContainer .info-container {
      top: 16px;
      left: 16px;
    }
  }
  @media (min-width: 900px) {
    .playerContainer .info-container {
      height: auto;
    }
  }
  .playerContainer .info-container-inverse {
    animation: 0.5s ease-in-out 0s 1 fadeOut;
  }
  .playerContainer .info-container .rating {
    ${ZeeFontBold(12, 16)}
    font-weight: bold;
    height: 16px;
    padding-bottom: 1px;
  }
  @media (min-width: 900px) {
    .playerContainer .info-container .rating {
      ${SetFontSize(24, 33)}
      height: 33px;
    }
  }
  .playerContainer .info-container .description {
    ${ZeeFontRegular(10, 14)}
    font-weight: normal;
    height: 28px;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
  @media (min-width: 900px) {
    .playerContainer .info-container .description {
      ${SetFontSize(18, 25)}
      height: auto;
    }
  }
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  @keyframes fadeOut {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
  .playerContainer .playerComp {
    ${ZeeFontRegular(12, 12)}
    user-select: none;
    /* Skip intro button */
    /* Watch credits */
    /* center control */
    /* text track
      important is used for overriding track inline style
      important impact check is done. Effected area is only track div */
    /* Bottom control */
    /* Hiding while playing */
    /* Controls disabled state */

    /* Tap to Unmute */
    .tap_to_unmute {
      display: flex;
      align-items: center;
      justify-content: center;
      left: 16px;
      color: white;
      width: 132px;
      height: 32px;
      background: #8230c6;
      position: absolute;
      bottom: 20%;
      border-radius: 6px;
      border: 0;
      font-size: 12px;
      z-index: 1000;
    }
  }
  .playerContainer .playerComp .vjs-tech {
    pointer-events: none;
  }
  .playerContainer .playerComp .vjs-icon-placeholder:before,
  .playerContainer .playerComp .vjs-skip-backward:before,
  .playerContainer .playerComp .vjs-skip-forward:before,
  .playerContainer .playerComp .vjs-cast-skip-forward:before,
  .playerContainer .playerComp .vjs-cast-skip-backward:before {
    font-family: ${zee5PlayerIcons.style.fontFamily} !important;
    font-style: normal !important;
    font-weight: normal !important;
  }
  .playerContainer .playerComp .vjs-big-play-button {
    display: none;
  }
  .playerContainer .playerComp .vjs-watermark-content {
    opacity: 0.99;
    padding: 5px;
    position: absolute;
    display: block;
    z-index: 2000;
    right: 0;
    top: 0 img;
    top-width: 50px;
  }
  .playerContainer .playerComp .watermarkContainer {
    user-select: none;
    position: absolute;
    left: 30px;
    z-index: 1;
    display: block;
    text-align: center;
    opacity: 0.5;
    top: 10px;
    animation: 0.5s ease-in-out 0s 1 fadeIn;
  }
  @media screen and (max-width: 599px) {
    .playerContainer .playerComp .watermarkContainer {
      left: 15px;
    }
  }
  .playerContainer .playerComp .watermarkContainer .watermarkIcon {
    margin-bottom: 3px;
  }
  @media screen and (max-width: 599px) {
    .playerContainer .playerComp .watermarkContainer .watermarkIcon {
      height: 25px;
      width: 25px;
    }
  }
  .playerContainer .playerComp .watermarkContainer .liveUsersContainer {
    ${SetFontSize(10, 14)}
    font-weight: 700;
    text-transform: uppercase;
  }
  .playerContainer .playerComp .watermarkContainer .liveUsersContainer img {
    vertical-align: middle;
    margin-right: 3px;
  }
  @media screen and (max-width: 599px) {
    .playerContainer .playerComp .watermarkContainer .liveUsersContainer {
      ${SetFontSize(8, 11)}
    }
  }

  .playerContainer .playerComp .shopIconContainer {
    user-select: none;
    cursor: pointer;
    position: absolute;
    top: 16px;
    right: 16px;
    height: 24px;
    width: 24px;
    &.adjustShopIconContainerOnChromecast {
      right: 60px;
      top: 10px;
    }
    &.adjustShopIconContainer {
      right: 36%;
    }
  }

  .playerContainer .playerComp .shopIconContainer .shopIcon {
    height: 24px;
    width: 24px;
    ${ZeeFontRegular(24, 24)};
    ${getCommerceIcons(CommerceIconsSet.SHOP)}
    &.adjustShopIconContainerOnChromecast {
      right: 60px;
      top: 10px;
    }
  }

  ${MQ.MediaLg} {
    .playerContainer .playerComp .shopIconContainer .shopIcon {
      height: 32px;
      width: 32px;
      ${ZeeFontRegular(32, 32)};
    }
    &.adjustShopIconContainerOnChromecast {
      right: 60px;
      top: 10px;
    }
  }

  .playerContainer .playerComp .initialShopIconContainer {
    position: absolute;
    top: 16px;
    right: 16px;
    user-select: none;
    display: flex;
    flex-direction: row-reverse;
    align-content: space-around;
    justify-content: space-between;
    align-items: flex-start;
    &.adjustShopIconContainerOnChromecast {
      right: 60px;
      top: 10px;
    }
  }

  .playerContainer .playerComp .initialShopIconContainer .shopIcon {
    height: 24px;
    width: 24px;
    ${ZeeFontRegular(24, 24)};
    ${getCommerceIcons(CommerceIconsSet.SHOP)}
    &.adjustShopIconContainerOnChromecast {
      right: 60px;
      top: 10px;
    }
  }

  ${MQ.MediaLg} {
    .playerContainer .playerComp .initialShopIconContainer .shopIcon {
      height: 32px;
      width: 32px;
      ${ZeeFontRegular(32, 32)};
    }
    &.adjustShopIconContainerOnChromecast {
      right: 60px;
      top: 10px;
    }
  }

  .playerContainer .playerComp
    .initialShopIconContainer
    .calloutContainer:after {
      content: '';
      width: 12px;
      height: 16px;
      transform: rotate(-45deg);
      background: ${colors.white};
      position: absolute;
      z-index: -1;
      top: 13px;
      left: 115px;
  }
}
${MQ.MobileXs} {
  .playerContainer .playerComp .initialShopIconContainer .calloutContainer {
    right: 8.5px;
    background: ${colors.white};
    border-radius: 6px;
    color: ${colors.black};
    position: relative;
    top: -6.5px;
    left: -10px;
    width: 123px;
    height: 42px;
    padding:10px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2;
    }
  }
  ${MQ.MediaLg} {
    .playerContainer .playerComp .initialShopIconContainer .calloutContainer {
    position:relative;
      top: -5px;
    }
  }

  .playerContainer .playerComp .vjs-live-control .vjs-live-display {
    background-color: #da1f26;
    ${SetFontSize(14, 25)}
    pointer-events: none;
    margin: 0;
    padding: 0 10px;
    border-radius: 3px;
  }
  @media screen and (max-width: 599px) {
    .playerContainer .playerComp .vjs-live-control .vjs-live-display {
      margin-top: 6px;
    }
  }
  .playerContainer .playerComp .skip_intro_button {
    ${ZeeFontRegular(12, 20)}
    text-align: center;
    display: flex;
    height: 35px;
    width: 80px;
    position: absolute;
    justify-content: center;
    align-items: center;
    opacity: 1;
    color: #a785ff;
    font-weight: bold;
    background-color: rgb(0, 0, 0);
    color: rgb(167, 133, 255);
    border-radius: 4px;
    bottom: 62px;
    right: 16px;
    padding: 0 10px;
    cursor: pointer;
    padding: 0;
    bottom: 90px;
  }
  @media screen and (max-width: 599px) {
    .playerContainer .playerComp .skip_intro_button {
      bottom: 60px;
    }
  }
  ${MQ.MediaSm} {
    .playerContainer .playerComp .skip_intro_button {
      ${SetFontSize(12, 3)}
    }
  }
  ${MQ.MediaMd} {
    .playerContainer .playerComp .skip_intro_button {
      line-height: 36px;
      border-radius: 6px;
    }
  }
  ${MQ.MediaLg} {
    .playerContainer .playerComp .skip_intro_button {
      bottom: 80px;
    }
  }
  .playerContainer .playerComp .watch_credits_button {
    ${ZeeFontBold(10, 24)}
    text-align: center;
    display: flex;
    height: 35px;
    position: absolute;
    justify-content: center;
    align-items: center;
    bottom: 40px;
    opacity: 1;
    font-weight: bold;
    background-color: rgb(255, 255, 255);
    color: rgb(130, 48, 198);
    border-radius: 4px;
    z-index: 1;
    bottom: 68px;
    right: 16px;
    padding: 0 10px;
    cursor: pointer;
  }
  .playerContainer .playerComp .watch_credits_button.carouselActive {
    bottom: 118px;
  }
  ${MQ.MediaSm} {
    .playerContainer .playerComp .watch_credits_button {
      ${SetFontSize(12, 30)}
    }
    .playerContainer .playerComp .watch_credits_button.carouselActive {
      bottom: 166px;
    }
  }
  ${MQ.MediaMd} {
    .playerContainer .playerComp .watch_credits_button {
      line-height: 3.6rem;
      border-radius: 6px;
    }
  }
  ${MQ.MediaLg} {
    .playerContainer .playerComp .watch_credits_button.carouselActive {
      bottom: 190px;
    }
  }
  ${MQ.MediaLgCommon} {
    .playerContainer .playerComp .watch_credits_button.carouselActive {
      bottom: 210px;
    }
  }
  .playerContainer .playerComp .vjs-skip-wrapper {
    position: absolute;
    top: 50%;
    left: 22%;
    right: 22%;
    transform: translateY(-50%);
    /* Center Play button */
    /* Rewind and forward button */
  }
  .playerContainer .playerComp .cast-player-seek-pause {
    position: absolute;
    top: 50%;
    left: 45%;
    right: 45%;
    transform: translateY(-50%);
  }
  ${MQ.MediaSm} {
    .playerContainer .playerComp .vjs-skip-wrapper {
      left: 30%;
      right: 30%;
    }
    .playerContainer .playerComp .cast-player-seek-pause {
      left: 45%;
      right: 45%;
    }
  }
  @media screen and (max-width: 599px) {
    .playerContainer .playerComp .vjs-skip-wrapper.upNextCarouselActive,
    .playerContainer .playerComp .cast-player-seek-pause.upNextCarouselActive {
      top: 40%;
    }
  }
  .playerContainer .playerComp .vjs-skip-wrapper .vjs-play-control,
  .playerContainer .playerComp .cast-player-seek-pause .vjs-play-control {
    margin: 0 auto;
    display: block;
    width: 32px;
    height: 32px;
    outline: none;
  }
  .playerContainer
    .playerComp
    .vjs-skip-wrapper
    .vjs-play-control
    .vjs-icon-placeholder:before,
  .playerContainer
    .playerComp
    .cast-player-seek-pause
    .vjs-play-control
    .vjs-icon-placeholder:before {
    content: 'P';
    bottom: 0;
    right: 0;
    ${SetFontSize(32, 32)}
    position: static;
  }
  .playerContainer
    .playerComp
    .vjs-skip-wrapper
    .vjs-play-control.vjs-playing
    .vjs-icon-placeholder:before,
  .playerContainer
    .playerComp
    .cast-player-seek-pause
    .vjs-play-control.vjs-playing
    .vjs-icon-placeholder:before {
    ${SetFontSize(48, 32)}
    margin-left: -9px;
  }
  ${MQ.MediaLg} {
    .playerContainer
      .playerComp
      .vjs-skip-wrapper
      .vjs-play-control.vjs-playing
      .vjs-icon-placeholder:before,
    .playerContainer
      .playerComp
      .cast-player-seek-pause
      .vjs-play-control.vjs-playing
      .vjs-icon-placeholder:before {
      margin-left: 0;
    }
  }
  ${MQ.MediaLg} {
    .playerContainer .playerComp .vjs-skip-wrapper .vjs-play-control,
    .playerContainer .playerComp .cast-player-seek-pause .vjs-play-control {
      width: 48px;
      height: 48px;
    }
    .playerContainer
      .playerComp
      .vjs-skip-wrapper
      .vjs-play-control
      .vjs-icon-placeholder:before,
    .playerContainer
      .playerComp
      .cast-player-seek-pause
      .vjs-play-control
      .vjs-icon-placeholder:before {
      ${SetFontSize(40, 40)}
    }
  }
  .playerContainer
    .playerComp
    .vjs-skip-wrapper
    .vjs-play-control.vjs-paused
    .vjs-icon-placeholder:before,
  .playerContainer
    .playerComp
    .cast-player-seek-pause
    .vjs-play-control.vjs-paused
    .vjs-icon-placeholder:before {
    content: 'p';
  }
  .playerContainer
    .playerComp
    .vjs-skip-wrapper
    .vjs-play-control.vjs-ended
    .vjs-icon-placeholder:before,
  .playerContainer
    .playerComp
    .cast-player-seek-pause
    .vjs-play-control.vjs-ended
    .vjs-icon-placeholder:before {
    content: '2';
  }
  .playerContainer .playerComp .vjs-skip-wrapper .vjs-skip-backward,
  .playerContainer .playerComp .vjs-skip-wrapper .vjs-skip-forward,
  .playerContainer .playerComp .vjs-skip-wrapper .vjs-cast-skip-forward,
  .playerContainer .playerComp .vjs-skip-wrapper .vjs-cast-skip-backward,
  .playerContainer .playerComp .cast-player-seek-pause .vjs-skip-backward,
  .playerContainer .playerComp .cast-player-seek-pause .vjs-skip-forward,
  .playerContainer .playerComp .cast-player-seek-pause .vjs-cast-skip-forward,
  .playerContainer .playerComp .cast-player-seek-pause .vjs-cast-skip-backward {
    position: absolute;
    width: 25px;
    height: 25px;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    cursor: pointer;
  }
  .playerContainer .playerComp .vjs-skip-wrapper .vjs-skip-backward:before,
  .playerContainer .playerComp .vjs-skip-wrapper .vjs-skip-forward:before,
  .playerContainer .playerComp .vjs-skip-wrapper .vjs-cast-skip-forward:before,
  .playerContainer .playerComp .vjs-skip-wrapper .vjs-cast-skip-backward:before,
  .playerContainer
    .playerComp
    .cast-player-seek-pause
    .vjs-skip-backward:before,
  .playerContainer .playerComp .cast-player-seek-pause .vjs-skip-forward:before,
  .playerContainer
    .playerComp
    .cast-player-seek-pause
    .vjs-cast-skip-forward:before,
  .playerContainer
    .playerComp
    .cast-player-seek-pause
    .vjs-cast-skip-backward:before {
    content: 'r';
    ${SetFontSize(25, 25)}
    padding: 0.625rem;
    margin: -10px;
  }
  ${MQ.MediaLg} {
    .playerContainer .playerComp .vjs-skip-wrapper .vjs-skip-backward,
    .playerContainer .playerComp .vjs-skip-wrapper .vjs-skip-forward,
    .playerContainer .playerComp .vjs-skip-wrapper .vjs-cast-skip-forward,
    .playerContainer .playerComp .vjs-skip-wrapper .vjs-cast-skip-backward,
    .playerContainer .playerComp .cast-player-seek-pause .vjs-skip-backward,
    .playerContainer .playerComp .cast-player-seek-pause .vjs-skip-forward,
    .playerContainer .playerComp .cast-player-seek-pause .vjs-cast-skip-forward,
    .playerContainer
      .playerComp
      .cast-player-seek-pause
      .vjs-cast-skip-backward {
      width: 100px;
      height: 100px;
      margin: 0px -32px;
      cursor: pointer;
    }
    .playerContainer .playerComp .vjs-skip-wrapper .vjs-skip-backward:before,
    .playerContainer .playerComp .vjs-skip-wrapper .vjs-skip-forward:before,
    .playerContainer
      .playerComp
      .vjs-skip-wrapper
      .vjs-cast-skip-forward:before,
    .playerContainer
      .playerComp
      .vjs-skip-wrapper
      .vjs-cast-skip-backward:before,
    .playerContainer
      .playerComp
      .cast-player-seek-pause
      .vjs-skip-backward:before,
    .playerContainer
      .playerComp
      .cast-player-seek-pause
      .vjs-skip-forward:before,
    .playerContainer
      .playerComp
      .cast-player-seek-pause
      .vjs-cast-skip-forward:before,
    .playerContainer
      .playerComp
      .cast-player-seek-pause
      .vjs-cast-skip-backward:before {
      ${SetFontSize(25, 16)}
    }
  }
  .playerContainer .playerComp .vjs-skip-wrapper .vjs-skip-forward,
  .playerContainer .playerComp .vjs-skip-wrapper .vjs-cast-skip-forward,
  .playerContainer .playerComp .cast-player-seek-pause .vjs-skip-forward,
  .playerContainer .playerComp .cast-player-seek-pause .vjs-cast-skip-forward {
    outline: none;
    left: auto;
    right: 0;
  }
  .playerContainer .playerComp .vjs-skip-wrapper .vjs-skip-forward:before,
  .playerContainer .playerComp .vjs-skip-wrapper .vjs-cast-skip-forward:before,
  .playerContainer .playerComp .cast-player-seek-pause .vjs-skip-forward:before,
  .playerContainer
    .playerComp
    .cast-player-seek-pause
    .vjs-cast-skip-forward:before {
    content: 'f';
  }
  .playerContainer .playerComp .chromeCastBtnContainer {
    position: absolute;
    margin-top: -4px;
    right: 2%;
    background: transparent;
    cursor: pointer;
    z-index: 1;
    width: 30px;
    height: 30px;
    display: block;
    &.adjustChromeCastIconContainer {
      margin-right: 38%;
    }
  }
  @media screen and (max-width: 599px) {
    .playerContainer .playerComp .chromeCastBtnContainer {
      margin-top: 0px;
      &.adjustChromeCastIconContainer {
        margin-right: 38%;
      }
    }
  }
  .playerContainer .playerComp .vjs-text-track-display {
    position: static;
  }
  .playerContainer .playerComp .vjs-text-track-display > div {
    position: static !important;
  }
  .playerContainer
    .playerComp
    .vjs-text-track-display
    > div
    .vjs-text-track-cue {
    position: absolute !important;
    left: 0 !important;
    right: 0 !important;
    top: auto !important;
    bottom: 58px !important;
    white-space: normal !important;
    max-width: 95%;
    margin: auto;
  }
  .playerContainer
    .playerComp
    .vjs-text-track-display
    > div
    .vjs-text-track-cue
    > div {
    ${ZeeFontRegular(8, 20)}
    background: rgba(0, 0, 0, 0.6) !important;
    padding: 3px 5px;
    border-radius: 3px;
    -webkit-text-size-adjust: 100%;
    text-size-adjust: 100%;
    overflow: hidden;
    line-height: 22px;
  }
  ${MQ.MediaSm} {
    .playerContainer
      .playerComp
      .vjs-text-track-display
      > div
      .vjs-text-track-cue {
      bottom: 74px !important;
    }
    .playerContainer
      .playerComp
      .vjs-text-track-display
      > div
      .vjs-text-track-cue
      > div {
      ${SetFontSize(14)}
    }
  }
  ${MQ.MediaMd} {
    .playerContainer
      .playerComp
      .vjs-text-track-display
      > div
      .vjs-text-track-cue {
      bottom: 90px !important;
    }
    .playerContainer
      .playerComp
      .vjs-text-track-display
      > div
      .vjs-text-track-cue
      > div {
      ${SetFontSize(16)}
    }
  }
  ${MQ.MediaLg} {
    .playerContainer
      .playerComp
      .vjs-text-track-display
      > div
      .vjs-text-track-cue
      > div {
      ${SetFontSize(22)}
    }
  }
  ${MQ.MediaXl} {
    .playerContainer
      .playerComp
      .vjs-text-track-display
      > div
      .vjs-text-track-cue
      > div {
      ${SetFontSize(22)}
    }
  }
  .playerContainer .playerComp .vjs-loading-spinner {
    ${SetFontSize(60, 16)}
    position: absolute;
    top: 50%;
    left: 50%;
    width: 1em;
    height: 1em;
    margin-left: -0.55em;
    margin-top: -0.5em;
    opacity: 0.75;
    border: none;
  }
  @media screen and (max-width: 599px) {
    .playerContainer .playerComp .vjs-loading-spinner {
      margin-left: -0.6em;
    }
  }
  .playerContainer .playerComp .vjs-loading-spinner::after {
    content: ''; /* Loading spinner icon */
    position: absolute;
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    background: url(https://www.zee5.com/assets/common/loading.gif) center/70px
      70px;
    position: absolute;
    width: 70px;
    height: 70px;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
  }
  .playerContainer .playerComp .vjs-control-bar {
    left: 16px;
    right: 16px;
    bottom: 16px;
    width: auto;
    background: transparent;
    height: 24px;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    z-index: 3;
    /* seek bar */
    /* play button */
    /* Volume block */
    /* Common button menu styling */
    /* Audio Selection button */
    /* Remaining time */
    /* Caption button */
    /* Subtitle button */
    /* Resoution */
    /* Fullscreen */
    /* Duration display */
  }
  .playerContainer .playerComp .vjs-control-bar > .vjs-button {
    margin-right: 16px;
    order: 2;
  }
  ${MQ.MediaXl} {
    .playerContainer .playerComp .vjs-control-bar > .vjs-button {
      margin-right: 32px;
    }
  }
  .playerContainer .playerComp .vjs-control-bar .vjs-progress-control {
    position: absolute;
    bottom: 30px;
    left: -10px;
    right: -10px;
    width: auto;
    height: 20px;
  }
  .playerContainer
    .playerComp
    .vjs-control-bar
    .vjs-progress-control
    .vjs-progress-holder {
    background-color: rgba(255, 255, 255, 0.3);
    height: 0.1254rem;
  }
  .playerContainer
    .playerComp
    .vjs-control-bar
    .vjs-progress-control
    .vjs-progress-holder
    .vjs-load-progress {
    background-color: rgba(255, 255, 255, 0.3);
  }
  ${MQ.MediaLg} {
    .playerContainer
      .playerComp
      .vjs-control-bar
      .vjs-progress-control
      .vjs-progress-holder
      .vjs-mouse-display
      .vjs-time-tooltip {
      background-position-y: 0 !important;
    }
  }
  .playerContainer
    .playerComp
    .vjs-control-bar
    .vjs-progress-control
    .vjs-progress-holder
    .vjs-play-progress {
    background: linear-gradient(
      270deg,
      #5730c7 0%,
      #5c2ade 48.11%,
      #2928d4 94.83%
    );
  }
  .playerContainer
    .playerComp
    .vjs-control-bar
    .vjs-progress-control
    .vjs-progress-holder
    .vjs-play-progress:before {
    ${SetFontSize(16, 12)}
    color: rgb(92, 42, 222);
    top: -0.3125rem;
    right: -0.5rem;
  }
  .playerContainer .playerComp .vjs-control-bar .vjs-button {
    width: 24px;
    height: 24px;
  }
  .playerContainer .playerComp .vjs-control-bar .vjs-button.go-live-button {
    ${SetFontSize(14, 25)}
    background-color: white;
    margin: 0;
    padding: 0px;
    margin-left: 20px;
    margin-right: 20px;
    border-radius: 6px;
    color: #e61c39;
    height: 25px;
    width: auto;
    padding: 0 5px;
    cursor: pointer;
  }
  @media screen and (max-width: 599px) {
    .playerContainer .playerComp .vjs-control-bar .vjs-button.go-live-button {
      font-size: 12px;
    }
  }
  .playerContainer
    .playerComp
    .vjs-control-bar
    .vjs-button.go-live-button
    .vjs-control-text {
    height: auto;
    width: auto;
    overflow: visible;
    clip: auto;
  }
  ${MQ.MediaXl} {
    .playerContainer .playerComp .vjs-control-bar .vjs-button {
      width: 32px;
      height: 32px;
    }
  }
  .playerContainer
    .playerComp
    .vjs-control-bar
    .vjs-button
    .vjs-icon-placeholder:before {
    ${SetFontSize(24, 24)}
  }
  .playerContainer .playerComp .vjs-control-bar .vjs-play-control {
    display: none;
  }
  .playerContainer .playerComp .vjs-control-bar .vjs-volume-panel {
    width: 40px;
  }
  ${MQ.MediaXl} {
    .playerContainer .playerComp .vjs-control-bar .vjs-volume-panel {
      width: 46px;
    }
  }
  .playerContainer
    .playerComp
    .vjs-control-bar
    .vjs-volume-panel
    .vjs-mute-control
    .vjs-icon-placeholder:before {
    content: 'U';
  }
  .playerContainer
    .playerComp
    .vjs-control-bar
    .vjs-volume-panel
    .vjs-mute-control.vjs-vol-0
    .vjs-icon-placeholder:before {
    content: 'O';
  }
  .playerContainer
    .playerComp
    .vjs-control-bar
    .vjs-volume-panel
    .vjs-volume-control.vjs-volume-horizontal {
    width: 8.6rem;
    transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  }
  @media screen and (max-width: 1199px) {
    .playerContainer
      .playerComp
      .vjs-control-bar
      .vjs-volume-panel
      .vjs-volume-control.vjs-volume-horizontal {
      display: none;
    }
  }
  .playerContainer
    .playerComp
    .vjs-control-bar
    .vjs-volume-panel
    .vjs-volume-control
    .vjs-volume-bar {
    background-color: rgb(66, 66, 66);
  }
  .playerContainer
    .playerComp
    .vjs-control-bar
    .vjs-volume-panel
    .vjs-volume-control
    .vjs-volume-bar
    .vjs-mouse-display {
    display: none;
  }
  .playerContainer
    .playerComp
    .vjs-control-bar
    .vjs-volume-panel
    .vjs-volume-control
    .vjs-volume-bar
    .vjs-volume-level {
    background: linear-gradient(
      270deg,
      #5730c7 0%,
      #5c2ade 48.11%,
      #2928d4 94.83%
    );
  }
  .playerContainer
    .playerComp
    .vjs-control-bar
    .vjs-volume-panel
    .vjs-volume-control
    .vjs-volume-bar
    .vjs-volume-level:before {
    color: rgb(92, 42, 222);
    ${SetFontSize(12)}
    right: -0.6rem;
  }
  ${MQ.MediaLg} {
    .playerContainer
      .playerComp
      .vjs-control-bar
      .vjs-volume-panel
      .vjs-volume-control.vjs-volume-horizontal {
      height: auto;
    }
    .playerContainer
      .playerComp
      .vjs-control-bar
      .vjs-volume-panel
      .vjs-volume-control
      .vjs-volume-bar {
      top: 50%;
      transform: translateY(-50%);
      margin: 0;
      width: 6em;
    }
  }
  ${MQ.MediaXl} {
    .playerContainer
      .playerComp
      .vjs-control-bar
      .vjs-volume-panel
      .vjs-volume-control
      .vjs-volume-bar {
      width: 6em;
    }
  }
  ${MQ.MediaLg} {
    .playerContainer .playerComp .vjs-control-bar .vjs-volume-panel.vjs-hover,
    .playerContainer .playerComp .vjs-control-bar .vjs-volume-panel:active {
      width: 11em;
      transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
      overflow: hidden;
    }
    .playerContainer
      .playerComp
      .vjs-control-bar
      .vjs-volume-panel.vjs-hover
      .vjs-volume-control.vjs-volume-horizontal,
    .playerContainer
      .playerComp
      .vjs-control-bar
      .vjs-volume-panel:active
      .vjs-volume-control.vjs-volume-horizontal {
      opacity: 1;
      transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
      margin-left: 16px;
    }
  }
  ${MQ.MediaXl} {
    .playerContainer .playerComp .vjs-control-bar .vjs-volume-panel.vjs-hover,
    .playerContainer .playerComp .vjs-control-bar .vjs-volume-panel:active {
      width: 12em;
    }
  }
  .playerContainer .playerComp .vjs-control-bar .vjs-menu-button .vjs-menu {
    z-index: 1;
    height: auto;
    background-color: rgba(6, 1, 7, 0.8);
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.3);
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;
    width: 180px;
    height: auto;
    bottom: 34px;
    right: -26px;
    left: auto;
    z-index: 2;
    border-radius: 8px;
    right: 50%;
    transform: translateX(50%);
  }
  @media screen and (max-width: 1199px) {
    .playerContainer .playerComp .vjs-control-bar .vjs-menu-button .vjs-menu {
      background: #060107;
    }
  }
  @media screen and (max-width: 599px) {
    .playerContainer .playerComp .vjs-control-bar .vjs-menu-button .vjs-menu {
      width: 160px;
      max-height: 124px;
    }
  }
  ${MQ.MediaLg} {
    .playerContainer .playerComp .vjs-control-bar .vjs-menu-button .vjs-menu {
      width: 284px;
      bottom: 42px;
    }
  }
  .playerContainer
    .playerComp
    .vjs-control-bar
    .vjs-menu-button
    .vjs-menu
    .vjs-menu-content {
    background-color: transparent;
    max-height: inherit;
    position: relative;
    bottom: unset;
  }
  .playerContainer
    .playerComp
    .vjs-control-bar
    .vjs-menu-button
    .vjs-menu
    .vjs-menu-content
    .vjs-menu-item {
    padding: 10px 15px 10px 42px;
    text-align: left;
    position: relative;
    margin: 2px;
  }
  .playerContainer
    .playerComp
    .vjs-control-bar
    .vjs-menu-button
    .vjs-menu
    .vjs-menu-content
    .vjs-menu-item
    .vjs-menu-item-text {
    text-transform: capitalize;
  }
  .playerContainer
    .playerComp
    .vjs-control-bar
    .vjs-menu-button
    .vjs-menu
    .vjs-menu-content
    .vjs-menu-item:hover {
    background-color: transparent;
  }
  ${MQ.MediaLg} {
    .playerContainer
      .playerComp
      .vjs-control-bar
      .vjs-menu-button
      .vjs-menu
      .vjs-menu-content
      .vjs-menu-item:hover {
      background-color: rgba(255, 255, 255, 0.06);
      border-radius: 6px;
    }
  }
  .playerContainer
    .playerComp
    .vjs-control-bar
    .vjs-menu-button
    .vjs-menu
    .vjs-menu-content
    .vjs-menu-item:after {
    content: '';
    position: absolute;
    background: rgba(255, 255, 255, 0.1);
    height: 2px;
    bottom: -1px;
    left: 0;
    right: 0;
  }
  .playerContainer
    .playerComp
    .vjs-control-bar
    .vjs-menu-button
    .vjs-menu
    .vjs-menu-content
    .vjs-menu-item:last-child:after {
    display: none;
  }
  .playerContainer
    .playerComp
    .vjs-control-bar
    .vjs-menu-button
    .vjs-menu
    .vjs-menu-content
    .vjs-menu-item.vjs-selected {
    background-color: transparent;
    color: rgb(255, 255, 255);
  }
  .playerContainer
    .playerComp
    .vjs-control-bar
    .vjs-menu-button
    .vjs-menu
    .vjs-menu-content
    .vjs-menu-item.vjs-selected:before {
    content: 't';
    ${SetFontSize(14, 16)}
    font-family: ${zee5PlayerIcons.style.fontFamily} !important;
    font-style: normal !important;
    font-weight: normal !important;
    position: absolute;
    left: 15px;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 14px;
    height: 14px;
  }
  ${MQ.MediaLg} {
    .playerContainer
      .playerComp
      .vjs-control-bar
      .vjs-menu-button
      .vjs-menu
      .vjs-menu-content
      .vjs-menu-item.vjs-selected {
      background-color: rgba(255, 255, 255, 0.06);
    }
  }
  ${MQ.MediaLg} {
    .playerContainer
      .playerComp
      .vjs-control-bar
      .vjs-menu-button
      .vjs-menu
      .vjs-menu-content
      .vjs-menu-item {
      padding: 15px 15px 15px 42px;
      margin: 5px 5px 12px 5px;
    }
    .playerContainer
      .playerComp
      .vjs-control-bar
      .vjs-menu-button
      .vjs-menu
      .vjs-menu-content
      .vjs-menu-item:last-child {
      margin-bottom: 5px;
    }
    .playerContainer
      .playerComp
      .vjs-control-bar
      .vjs-menu-button
      .vjs-menu
      .vjs-menu-content
      .vjs-menu-item:after {
      left: -5px;
      right: -5px;
      bottom: -7px;
    }
  }
  ${MQ.MediaLg} {
    .playerContainer .playerComp .vjs-control-bar .vjs-audio-button {
      width: 24px;
    }
    .playerContainer
      .playerComp
      .vjs-control-bar
      .vjs-audio-button.vjs-control {
      width: auto;
    }
    .playerContainer
      .playerComp
      .vjs-control-bar
      .vjs-audio-button.vjs-control.vjs-hover
      .vjs-menu {
      display: none;
    }
  }
  .playerContainer
    .playerComp
    .vjs-control-bar
    .vjs-audio-button
    .vjs-audio-button {
    position: static;
  }
  .playerContainer
    .playerComp
    .vjs-control-bar
    .vjs-audio-button
    .vjs-audio-button
    .vjs-icon-placeholder:before {
    content: 'T';
  }
  .playerContainer .playerComp .vjs-control-bar .vjs-remaining-time {
    padding: 0;
  }
  .playerContainer .playerComp .vjs-control-bar .vjs-subs-caps-button {
    display: none;
  }
  .playerContainer
    .playerComp
    .vjs-progress-control
    .vjs-vtt-thumbnail-display {
    position: absolute;
    height: 113px;
    width: 200px;
    bottom: 20px;
    margin-left: -100px;
    pointer-events: none;
  }
  @media screen and (max-width: 599px) {
    .playerContainer
      .playerComp
      .vjs-control-bar
      .js-focus-visible
      .vjs-menu
      li.vjs-menu-item:hover,
    .playerContainer
      .playerComp
      .vjs-control-bar
      .vjs-menu
      li.vjs-menu-item:focus {
      background: transparent;
    }
  }
  ${MQ.MediaLg} {
    .playerContainer
      .playerComp
      .vjs-control-bar
      .vjs-subtitles-button.vjs-control {
      position: static;
    }
    .playerContainer
      .playerComp
      .vjs-control-bar
      .vjs-subtitles-button.vjs-control
      .vjs-menu {
      right: 0;
      transform: none;
    }
    .playerContainer
      .playerComp
      .vjs-control-bar
      .vjs-subtitles-button.vjs-hover
      .vjs-menu {
      display: none;
    }
  }
  ${MQ.MediaXl} {
    .playerContainer
      .playerComp
      .vjs-control-bar
      .vjs-subtitles-button.vjs-control {
      position: relative;
    }
    .playerContainer
      .playerComp
      .vjs-control-bar
      .vjs-subtitles-button.vjs-control
      .vjs-menu {
      right: 50%;
      transform: translateX(50%);
    }
  }
  .playerContainer
    .playerComp
    .vjs-control-bar
    .vjs-subtitles-button
    .vjs-subtitles-button {
    position: relative;
  }
  .playerContainer
    .playerComp
    .vjs-control-bar
    .vjs-subtitles-button
    .vjs-subtitles-button
    .vjs-icon-placeholder:before {
    content: 's';
  }
  .playerContainer .playerComp .vjs-control-bar .vjs-http-source-selector {
    position: static;
    order: 3;
  }
  .playerContainer
    .playerComp
    .vjs-control-bar
    .vjs-http-source-selector
    .vjs-menu-button {
    text-align: center;
    padding: 0;
  }
  .playerContainer
    .playerComp
    .vjs-control-bar
    .vjs-http-source-selector
    .vjs-menu-button:before {
    content: '';
    background-image: url("data:image/svg+xml;charset=utf8,%3C?xml version='1.0' encoding='utf-8'?%3E%3C!-- Generator: Adobe Illustrator 22.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='36px' height='36px' viewBox='0 0 36 36' style='enable-background:new 0 0 36 36;' xml:space='preserve'%3E%3Cstyle type='text/css'%3E .st0{fill:%23FFFFFF;} %3C/style%3E%3Cpath class='st0' d='M32.9,19.7c0.1-1.1,0.1-2.3,0-3.3c-0.1-0.3-0.3-0.5-0.6-0.5c-1.5,0-3-0.9-3.5-2.3c-0.6-1.4-0.2-3.1,1-4.1 c0.2-0.2,0.2-0.5,0-0.7c-0.7-0.9-1.5-1.7-2.4-2.4c-0.2-0.2-0.5-0.1-0.8,0.1c-0.7,0.8-1.7,1.2-2.8,1.2c-0.5,0-0.9-0.1-1.4-0.3 c-1.5-0.6-2.4-2.1-2.3-3.7c0-0.3-0.2-0.5-0.4-0.5c-1.1-0.1-2.3-0.1-3.4,0c-0.3,0-0.5,0.3-0.5,0.5c0.1,1.6-0.9,3-2.3,3.6 c-0.4,0.2-0.9,0.2-1.3,0.2c-1.1,0-2.1-0.4-2.8-1.2C9.3,6.2,9.2,6.1,9.1,6.1c-0.1,0-0.2,0-0.3,0.1C7.8,6.9,7,7.7,6.3,8.6 c-0.2,0.2-0.1,0.5,0,0.7c1.2,1.1,1.5,2.7,0.9,4.3c-0.7,1.4-2.1,2.3-3.7,2.2c-0.3,0-0.5,0.2-0.5,0.5c-0.1,1.1-0.1,2.3,0,3.3 c0.1,0.3,0.3,0.6,0.7,0.5l0.1,0c1.5,0,2.8,0.9,3.4,2.3c0.6,1.4,0.2,3.1-0.9,4.2c-0.2,0.2-0.2,0.5,0,0.7c0.7,0.9,1.5,1.7,2.4,2.4 c0.2,0.2,0.5,0.2,0.8-0.1c0.7-0.8,1.8-1.2,2.8-1.2c0.5,0,0.9,0.1,1.4,0.3c1.4,0.6,2.3,2.1,2.3,3.7c0,0.3,0.2,0.5,0.5,0.5 c1.1,0.1,2.3,0.1,3.4,0c0.3,0,0.5-0.3,0.5-0.5c-0.1-1.6,0.9-3,2.3-3.6c0.4-0.2,0.9-0.3,1.3-0.2c1.1,0,2.1,0.4,2.8,1.2 c0.1,0.1,0.3,0.2,0.4,0.2c0.1,0,0.2,0,0.3-0.1c0.9-0.7,1.7-1.5,2.4-2.4c0.2-0.2,0.1-0.5,0-0.7c-1.1-1-1.5-2.7-1-4.1s1.9-2.4,3.5-2.4 h0.3C32.7,20.2,32.9,20,32.9,19.7L32.9,19.7z M35.9,20.1c-0.2,1.8-1.7,3.1-3.5,3.1h-0.3c-0.3,0-0.6,0.2-0.7,0.5 c-0.1,0.3,0,0.6,0.2,0.8c1.4,1.3,1.5,3.3,0.4,4.8c-0.9,1.1-1.8,2-2.9,2.9c-0.6,0.5-1.4,0.7-2.2,0.7c-1,0-1.9-0.4-2.6-1.1 c-0.2-0.2-0.4-0.3-0.6-0.3c-0.1,0-0.1,0-0.2,0c-0.3,0.1-0.5,0.4-0.5,0.7c0.1,1.8-1.3,3.4-3.1,3.6c-1.3,0.1-2.7,0.1-4.1,0 c-1.9-0.2-3.2-1.8-3.1-3.7c0-0.3-0.2-0.6-0.4-0.7c-0.1,0-0.1,0-0.2,0c-0.2,0-0.5,0.1-0.6,0.2C10.3,33,8.2,33.2,6.7,32 c-1.1-0.9-2-1.8-2.8-2.9c-1.2-1.4-1-3.5,0.4-4.8c0.2-0.2,0.3-0.5,0.2-0.8c-0.1-0.3-0.4-0.4-0.6-0.4c-1.9,0-3.4-1.3-3.7-3.1 c-0.2-1.4-0.2-2.7,0-4.1c0.2-1.8,1.8-3.2,3.6-3.1c0.4,0,0.7-0.2,0.8-0.4c0.1-0.3,0-0.6-0.2-0.8C3,10.3,2.8,8.2,4,6.7 c0.9-1.1,1.8-2,2.9-2.9c0.6-0.5,1.4-0.7,2.2-0.7c1,0,1.9,0.4,2.6,1.1c0.2,0.2,0.4,0.3,0.7,0.3c0.1,0,0.1,0,0.2,0 c0.3-0.1,0.5-0.4,0.5-0.7c-0.1-1.8,1.3-3.4,3.1-3.6c1.3-0.1,2.7-0.1,4.1,0C22,0.3,23.3,2,23.2,3.8c0,0.3,0.2,0.6,0.4,0.7 c0.1,0,0.1,0,0.2,0c0.2,0,0.5-0.1,0.6-0.2C25.7,3,27.8,2.8,29.3,4c1.1,0.8,2,1.8,2.8,2.9c1.2,1.4,1,3.6-0.4,4.8 c-0.2,0.2-0.3,0.5-0.2,0.8c0.1,0.3,0.4,0.5,0.7,0.5c1.8,0,3.3,1.3,3.6,3.1C36,17.4,36,18.7,35.9,20.1L35.9,20.1z M18,22 c2.2,0,4-1.8,4-4c0-1.6-1-3.1-2.5-3.7c-1.5-0.6-3.2-0.3-4.4,0.9s-1.5,2.9-0.9,4.4C14.9,21,16.4,22,18,22z M18,25 c-2.8,0-5.4-1.7-6.5-4.3S11,15,13,13c2-2,5-2.6,7.6-1.5S25,15.1,25,18C25,21.8,21.9,25,18,25L18,25z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-size: 24px;
    background-position: center;
    width: 24px;
    height: 24px;
    display: inline-block;
  }
  .playerContainer
    .playerComp
    .vjs-control-bar
    .vjs-http-source-selector.vjs-hover
    .vjs-menu {
    display: none;
  }
  .playerContainer
    .playerComp
    .vjs-control-bar
    .vjs-http-source-selector
    .vjs-menu {
    right: 0;
    transform: none;
  }
  .playerContainer .playerComp .vjs-control-bar .vjs-button:hover .vjs-menu {
    background: #060107;
  }
  .playerContainer .playerComp .vjs-control-bar .vjs-fullscreen-control {
    margin-right: 0;
    order: 3;
  }
  .playerContainer
    .playerComp
    .vjs-control-bar
    .vjs-fullscreen-control
    .vjs-icon-placeholder:before {
    content: 'F';
  }
  ${MQ.MediaLg} {
    .playerContainer .playerComp .vjs-control-bar {
      height: 1.5625rem;
      bottom: 16px;
      /* Remaining time */
      /* Resoution */
    }
    .playerContainer .playerComp .vjs-control-bar .vjs-progress-control {
      bottom: 34px;
    }
    .playerContainer
      .playerComp
      .vjs-control-bar
      .vjs-progress-control:hover
      .vjs-play-progress
      .vjs-time-tooltip {
      display: none;
    }
    .playerContainer
      .playerComp
      .vjs-control-bar
      .vjs-progress-control
      .vjs-progress-holder {
      height: 4px;
    }
    .playerContainer
      .playerComp
      .vjs-control-bar
      .vjs-progress-control
      .vjs-progress-holder
      .vjs-load-progress
      div {
      background: transparent;
    }
    .playerContainer
      .playerComp
      .vjs-control-bar
      .vjs-progress-control
      .vjs-progress-holder
      .vjs-play-progress:before {
      top: -0.275rem;
    }
    .playerContainer
      .playerComp
      .vjs-control-bar
      .vjs-control
      .vjs-icon-placeholder:before {
      ${SetFontSize(24, 24)}
    }
    .playerContainer .playerComp .vjs-control-bar .vjs-remaining-time {
      ${SetFontSize(14, 25)}
    }
    .playerContainer
      .playerComp
      .vjs-control-bar
      .vjs-http-source-selector
      .vjs-menu-button:before {
      background-size: 25px;
      width: 25px;
    }
  }
  ${MQ.MediaXl} {
    .playerContainer .playerComp .vjs-control-bar {
      height: 2rem;
      /* Remaining time */
      /* Resoution */
    }
    .playerContainer .playerComp .vjs-control-bar .vjs-progress-control {
      bottom: 40px;
    }
    .playerContainer
      .playerComp
      .vjs-control-bar
      .vjs-progress-control
      .vjs-progress-holder
      .vjs-load-progress
      div {
      background: transparent;
    }
    .playerContainer
      .playerComp
      .vjs-control-bar
      .vjs-control
      .vjs-icon-placeholder:before {
      ${SetFontSize(32, 32)}
    }
    .playerContainer .playerComp .vjs-control-bar .vjs-remaining-time {
      ${SetFontSize(14, 25)}
    }
    .playerContainer
      .playerComp
      .vjs-control-bar
      .vjs-http-source-selector
      .vjs-menu-button:before {
      background-size: 32px;
      width: 32px;
      height: 32px;
    }
  }
  .playerContainer .playerComp .vjs-control-bar .vjs-time-control {
    display: block;
    padding: 0;
    min-width: 0;
    line-height: 1.5rem;
    display: flex;
  }
  .playerContainer
    .playerComp
    .vjs-control-bar
    .vjs-time-control.vjs-time-divider {
    padding: 0 5px;
  }
  ${MQ.MediaLg} {
    .playerContainer .playerComp .vjs-control-bar .vjs-time-control {
      line-height: 1.5625rem;
    }
    .playerContainer
      .playerComp
      .vjs-control-bar
      .vjs-time-control.vjs-time-divider {
      ${SetFontSize(16, 25)}
    }
  }
  ${MQ.MediaXl} {
    .playerContainer .playerComp .vjs-control-bar .vjs-time-control {
      ${SetFontSize(16, 32)}
    }
    .playerContainer
      .playerComp
      .vjs-control-bar
      .vjs-time-control.vjs-time-divider {
      ${SetFontSize(16, 32)}
    }
  }
  .playerContainer .playerComp .vjs-control-bar .vjs-duration {
    margin-right: auto;
  }
  .playerContainer .playerComp .vjs-control-bar .vjs-remaining-time {
    display: none;
  }
  .playerContainer .playerComp .vjs-control-bar .vjs-current-time-display,
  .playerContainer .playerComp .vjs-control-bar .vjs-duration-display {
    ${SetFontSize(14.4, 24)}
  }
  ${MQ.MediaLg} {
    .playerContainer .playerComp .vjs-control-bar .vjs-current-time-display,
    .playerContainer .playerComp .vjs-control-bar .vjs-duration-display {
      ${SetFontSize(16.8, 25)}
    }
  }
  ${MQ.MediaLg} {
    .playerContainer .playerComp .vjs-control-bar .vjs-current-time-display,
    .playerContainer .playerComp .vjs-control-bar .vjs-duration-display {
      ${SetFontSize(16.8, 24)}
    }
  }
  ${MQ.MediaXl} {
    .playerContainer .playerComp .vjs-control-bar .vjs-current-time-display,
    .playerContainer .playerComp .vjs-control-bar .vjs-duration-display {
      ${SetFontSize(16.8, 32)}
    }
  }
  .playerContainer
    .playerComp
    .vjs-control-bar
    .vjs-time-control
    .vjs-time-divider {
    display: block;
    padding-left: 1em;
    padding-right: 1em;
    min-width: 1em;
  }
  .playerContainer .playerComp .eduauraaMessage {
    ${SetFontSize(12)}
    bottom: 80px;
    left: 16px;
    background: transparent;
    color: #fff;
    position: absolute;
  }
  ${MQ.MediaLg} {
    .playerContainer .playerComp .eduauraaMessage {
      bottom: 90px;
    }
  }
  .playerContainer
    .playerComp.vjs-fullscreen
    .vjs-control-bar
    .vjs-fullscreen-control
    .vjs-icon-placeholder:before {
    content: 'E';
  }
  .playerContainer
    .playerComp.vjs-has-started.vjs-user-inactive.vjs-playing
    .vjs-skip-wrapper,
  .playerContainer
    .playerComp.vjs-has-started.vjs-user-inactive.vjs-playing
    .cast-player-seek-pause,
  .playerContainer
    .playerComp.vjs-has-started.vjs-user-inactive.vjs-playing
    .chromeCastBtnContainer {
    visibility: visible;
    opacity: 0;
    transition: visibility 1s, opacity 1s;
    &.adjustChromeCastIconContainer {
      margin-right: 38%;
    }
  }
  .playerContainer
    .playerComp.vjs-has-started.vjs-user-inactive.vjs-playing
    .vjs-text-track-display
    > div
    .vjs-text-track-cue {
    bottom: 15px !important;
  }
  ${MQ.MediaMd} {
    .playerContainer
      .playerComp.vjs-has-started.vjs-user-inactive.vjs-playing
      .vjs-text-track-display
      > div
      .vjs-text-track-cue {
      bottom: 20px !important;
    }
  }
  .tobaccoAdvisory {
    user-select: none;
    position: absolute;
    left: 0px;
    z-index: 1;
    display: block;
    text-align: center;
    bottom: 10px;
    padding: 5px;
    animation: 0.5s ease-in-out 0s 1 fadeIn;
    background: rgba(0, 0, 0, 0.5);
    .tobaccoAdvisoryIcon {
      vertical-align: middle;
      margin: 0 10px;
      max-height: 40px;
      width: auto;
      @media screen and (max-width: 599px) {
        max-height: 20px;
      }
    }
  }
  .playerContainer
    .playerComp.vjs-user-active
    .chromeCastBtnContainer
    .chromeCastIcon {
    display: block !important;
  }

  .playerContainer .playerComp.vjs-user-active .scoreMainContainer {
    display: flex !important;
    background: ${colors.OnHoverPinScoreCardBg};

    .scoreContainer {
      display: flex !important;
    }
  }

  .playerContainer
    .playerContainer
    .playerComp.vjs-user-inactive
    .cast-player-seek-pause,
  .playerContainer .playerComp.vjs-user-inactive .chromeCastBtnContainer {
    visibility: visible;
    opacity: 0;
    transition: visibility 1s, opacity 1s;
    &.adjustChromeCastIconContainer {
      margin-right: 38%;
    }
  }
  .playerContainer .playerComp.vjs-controls-disabled .vjs-skip-wrapper,
  .playerContainer .playerComp.vjs-controls-disabled .cast-player-seek-pause,
  .playerContainer .playerComp.vjs-controls-disabled .chromeCastBtnContainer {
    display: none;
    &.adjustChromeCastIconContainer {
      margin-right: 38%;
    }
  }
  .playerContainer
    .playerComp
    .video-tag_ima-ad-container
    .video-tag_ima-controls-div
    .video-tag_ima-mute-div,
  .playerContainer
    .playerComp
    .video-tag_ima-ad-container
    .video-tag_ima-controls-div
    .video-tag_ima-slider-div,
  .playerContainer
    .playerComp
    .video-tag_ima-ad-container
    .video-tag_ima-controls-div
    .video-tag_ima-slider-level-div,
  .playerContainer
    .playerComp
    .video-tag_ima-ad-container
    .video-tag_ima-controls-div
    .video-tag_ima-fullscreen-div {
    display: none;
  }
  .playerContainer .playerComp .video-tag_ima-ad-container {
    z-index: 90 !important;
  }

  .playerContainer .playerComp .scoreMainContainer {
    display: flex;
    padding: 8px 8px 8px 4px;
    justify-content: center;
    align-items: center;
    gap: 16px;

    position: absolute;
    top: 3px;
    left: 2px;
    z-index: 100;
    border-radius: 4px;
    background: ${colors.PinScoreCardBg};

    @media screen and (min-width: 600px) {
      top: 5px;
      left: 5px;
    }

    @media screen and (min-width: 900px) {
      top: 5px;
    }

    @media screen and (min-width: 1200px) {
      top: 12px;
    }

    @media screen and (min-width: 1366px) {
      left: 10px;
    }

    @media screen and (min-width: 1800px) {
      top: 15px;
      left: 15px;
    }

    .scoreContainer {
      cursor: pointer;
      display: flex;
      padding-left: 4px;
      justify-content: center;
      align-items: center;
      gap: 4px;

      #scoreContent::after {
        content: '...';
        @media screen and (min-width: 600px) {
          content: '';
        }
      }

      #scoreContentB {
        display: none;
        @media screen and (min-width: 600px) {
          display: block;
        }
      }
      .teamContentB {
        display: none;
        @media screen and (min-width: 600px) {
          display: block;
        }
      }
      #versus {
        display: none;
        @media screen and (min-width: 600px) {
          display: block;
        }
      }

      .liveDot {
        min-width: 5px;
        min-height: 5px;
        max-width: 5px;
        max-height: 5px;
        background-color: ${colors.liveDotColor};
        border-radius: 50%;
      }

      .teamContainer {
        color: ${colors.PrimaryWhiteColor};
        text-align: center;
        ${ZeeFontBold(16, 22)};
      }

      .scorecardForSticky {
        display: flex;
        gap: 4px;
        color: ${colors.PinScoreCardText};
        text-align: center;
        ${ZeeFontMedium(14, 20)};
      }
    }

    .pinContainer {
      cursor: pointer;
      width: 24px;
      height: 24px;
    }
  }

  .playerContainer .networkError .networkErrorContainer {
    border-radius: 8px;
    position: absolute;
    margin: auto;
    background-color: #350e30;
    opacity: 0.8;
    width: 80%;
    height: fit-content;
    top: 50%;
    right: 0;
    left: 0;
    transform: translateY(-50%);
    padding: 20px;
  }
  .playerContainer .networkError .networkErrorContainer .networkImage {
    padding-top: 20px;
  }
  .playerContainer .networkError .networkErrorContainer .networkErrorMsg {
    color: white;
    font-size: 16px;
    line-height: 1.8;
  }
  @media screen and (max-width: 599px) {
    .playerContainer .networkError .networkErrorContainer .networkErrorMsg {
      font-size: 12px;
      line-height: 1.2;
    }
  }
  .playerContainer .networkError .networkErrorContainer .retryButton {
    padding-top: 1.2rem;
    padding-bottom: 20px;
  }
  .playerContainer .networkError .networkErrorContainer .retryButton .retry {
    text-align: center;
    color: #ff0091;
    background-color: transparent;
    background-repeat: no-repeat;
    border: none;
    cursor: pointer;
    outline: none;
    font-size: 18px;
    font-weight: 200;
  }
  @media screen and (max-width: 599px) {
    .playerContainer .networkError .networkErrorContainer .retryButton .retry {
      font-size: 16px;
    }
  }
  .playerContainer .trailerInfoContainer,
  .playerContainer .freeMinutesInfoContainer {
    margin-top: 16px;
    margin-bottom: 16px;
    height: 17px;
    font-size: 12px;
    left: 32px;
    background: transparent;
    color: #fff;
    position: absolute;
    width: 265px;
    font-family: ${notasansRegular.style.fontFamily};
  }
  @media (min-width: 1800px) {
    .playerContainer .trailerInfoContainer,
    .playerContainer .freeMinutesInfoContainer {
      margin-top: 24px;
      margin-bottom: 50px;
      font-size: 16px;
      left: 24px;
      width: 380px;
      height: 22px;
    }
  }
  @media (min-width: 1200px) {
    .playerContainer .trailerInfoContainer,
    .playerContainer .freeMinutesInfoContainer {
      margin-top: 24px;
      margin-bottom: 24px;
      font-size: 14px;
      height: 19px;
      font-weight: 600;
      font-family: ${notasansMedium.style.fontFamily};
    }
  }
  @media (min-width: 600px) {
    .playerContainer .trailerInfoContainer,
    .playerContainer .freeMinutesInfoContainer {
      margin-top: 24px;
      margin-bottom: 24px;
      height: 22px;
      font-size: 16px;
      left: 32px;
      width: 350px;
    }
  }
  .playerContainer .freeMinutesInfoContainer {
    left: 90px;
    top: 10px;
    margin-top: 5px;
    animation: 0.5s ease-in-out 0s 1 fadeIn;
  }
  @media screen and (max-width: 599px) {
    .playerContainer .freeMinutesInfoContainer {
      position: absolute;
      left: 55px;
      margin: 0;
    }
  }
  .playerContainer .freeMinutesInfoContainer .freeMinutesInfoTimer {
    font-weight: 400;
    font-size: 11px;
    line-height: 18px;
  }
  .playerContainer .freeMinutesInfoContainer .buy-plan-btn {
    background: rgba(255, 255, 255, 0.16);
    color: rgb(255, 255, 255);
    padding: 4px 8px;
    border-radius: 4px;
    margin-top: 7px;
    display: inline-block;
    cursor: pointer;
    font-weight: 500;
    font-size: 10px;
    line-height: 14px;
  }
  .playerContainer .freeMinutesInfoContainer .buy-plan-btn:before {
    content: 'P';
    ${SetFontSize(14)}
    font-family: '${IconsConstants.INITIAL_LOAD_ICONS}';
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    margin: 0 5px 0 0;
    position: relative;
    top: 1px;
  }
  ${MQ.MediaLg} {
    .playerContainer .freeMinutesInfoContainer .buy-plan-btn:before {
      ${SetFontSize(16)}
      margin-right: 6px;
      top: 2px;
    }
  }
  @media screen and (max-width: 599px) {
    .playerContainer .freeMinutesInfoContainer .buy-plan-btn {
      padding: 3px 6px;
    }
  }
  .playerContainer #ad-container {
    top: 0em;
    position: absolute;
    display: none;
    width: 100%;
    height: 100%;
    z-index: 2000;
  }
  .playerContainer #zee-ad-container {
    top: 0em;
    position: absolute;
    display: none;
    width: 100%;
    height: 100%;
    pointer-events: none;
  }
  .playerContainer #zee-controls-div {
    bottom: 0em;
    height: 2em;
    position: absolute;
    overflow: hidden;
    display: block;
    opacity: 1;
    background-color: rgba(7, 20, 30, 0.7);
    background: -moz-linear-gradient(
      bottom,
      rgba(7, 20, 30, 0.7) 0%,
      rgba(7, 20, 30, 0) 100%
    ); /* FF3.6+ */
    background: -webkit-gradient(
      linear,
      left bottom,
      left top,
      color-stop(0%, rgba(7, 20, 30, 0.7)),
      color-stop(100%, rgba(7, 20, 30, 0))
    ); /* Chrome,Safari4+ */
    background: -webkit-linear-gradient(
      bottom,
      rgba(7, 20, 30, 0.7) 0%,
      rgba(7, 20, 30, 0) 100%
    ); /* Chrome10+,Safari5.1+ */
    background: -o-linear-gradient(
      bottom,
      rgba(7, 20, 30, 0.7) 0%,
      rgba(7, 20, 30, 0) 100%
    ); /* Opera 11.10+ */
    background: -ms-linear-gradient(
      bottom,
      rgba(7, 20, 30, 0.7) 0%,
      rgba(7, 20, 30, 0) 100%
    ); /* IE10+ */
    background: linear-gradient(
      to top,
      rgba(7, 20, 30, 0.7) 0%,
      rgba(7, 20, 30, 0) 100%
    ); /* W3C */
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="#0007141E", endColorstr="#07141E",GradientType=0 ); /* IE6-9 */
  }
  .playerContainer #zee-countdown-div {
    ${SetFontSize(14)}
    margin-left: 15px;
    color: #ffffff;
    text-shadow: 0 0 0.2em #000;
    cursor: default;
  }
  .playerContainer #zee-seek-bar-div {
    bottom: 0;
    height: 0.4em;
    position: absolute;
    background: rgba(255, 255, 255, 0.4);
  }
  .playerContainer #zee-progress-div {
    width: 0em;
    height: 0.4em;
    background-color: #ecc546;
  }
  .playerContainer .vjs-workinghover .vjs-menu-button-popup:hover .vjs-menu {
    display: none;
  }
  .playerContainer
    .playerComp
    .vjs-control-bar
    .vjs-audio-button
    .vjs-audio-button
    .vjs-icon-placeholder:before {
    background-image: url("data:image/svg+xml,%3Csvg width='36' height='20' viewBox='0 0 36 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M30.5446 18.2013C30.1401 18.6081 30.1415 19.2842 30.5477 19.6927C30.9539 20.1012 31.6262 20.1026 32.0307 19.6958C37.3387 14.3576 37.3208 5.6676 31.9908 0.307288C31.5846 -0.101212 30.9123 -0.102612 30.5078 0.3042C30.1033 0.711012 30.1047 1.38712 30.5109 1.79562C35.0186 6.32898 35.0337 13.6867 30.5446 18.2013Z' fill='%23F2F2F2'/%3E%3Cpath d='M27.6957 15.1621C27.2915 15.5685 27.2935 16.2446 27.7 16.6535C28.1065 17.0623 28.7788 17.0643 29.183 16.6578C32.8502 12.9698 32.8328 6.94444 29.1443 3.23499C28.7378 2.82615 28.0655 2.82419 27.6613 3.23067C27.2572 3.63714 27.2591 4.31325 27.6656 4.72209C30.5311 7.6039 30.5545 12.287 27.6957 15.1621Z' fill='%23F2F2F2'/%3E%3Cpath d='M5.45537 18.2013C5.85988 18.6081 5.85849 19.2842 5.4523 19.6927C5.04611 20.1012 4.37382 20.1026 3.96931 19.6958C-1.33866 14.3576 -1.32077 5.6676 4.00922 0.307288C4.41541 -0.101212 5.0877 -0.102612 5.49221 0.3042C5.89672 0.711012 5.89533 1.38712 5.48914 1.79562C0.981432 6.32898 0.966284 13.6867 5.45537 18.2013Z' fill='%23F2F2F2'/%3E%3Cpath d='M8.30428 15.1621C8.70846 15.5685 8.70651 16.2446 8.29998 16.6535C7.89346 17.0623 7.22117 17.0643 6.817 16.6578C3.14985 12.9698 3.16721 6.94444 6.85568 3.23499C7.26221 2.82615 7.93449 2.82419 8.33867 3.23067C8.74284 3.63714 8.7409 4.31325 8.33437 4.72209C5.46887 7.6039 5.44548 12.287 8.30428 15.1621Z' fill='%23F2F2F2'/%3E%3Cpath d='M13.728 10.1981L13.2282 8.54796H10.7151L10.2153 10.1981H8.64049L11.0734 3.23713L12.8604 3.23713L15.3028 10.1981H13.728ZM12.8793 7.31509C12.4172 5.81984 12.1563 4.97421 12.0966 4.77822C12.04 4.58222 11.9991 4.42732 11.974 4.31352C11.8703 4.71815 11.5732 5.71868 11.0829 7.31509H12.8793Z' fill='%23F2F2F2'/%3E%3Cpath d='M19.7526 9.34893C20.3315 9.05099 20.9393 8.90202 21.5761 8.90202C22.1448 8.90202 22.5926 9.0527 22.9195 9.35407C23.2498 9.65544 23.4149 10.051 23.4149 10.5407C23.4149 11.0784 23.2055 11.5116 22.7867 11.8404C22.9195 11.8917 23.1051 11.9174 23.3434 11.9174C23.592 11.9174 23.8236 11.866 24.0381 11.7633C24.256 11.6606 24.474 11.4962 24.6919 11.2702L24.6919 10.1708H24.0279V9.00989H27.0824V10.1708H26.0966L26.0966 15.5544H24.6919V12.6212C24.382 12.8027 23.9819 12.9089 23.4916 12.9397C23.5256 13.0835 23.5426 13.2136 23.5426 13.3301C23.5426 13.8404 23.3775 14.2342 23.0472 14.5116C22.7203 14.7856 22.2537 14.9225 21.6476 14.9225C21.1947 14.9225 20.7844 14.8386 20.4166 14.6708C20.0522 14.503 19.693 14.2017 19.3388 13.7667C18.9847 13.3284 18.6373 12.7034 18.2968 11.8917L19.5023 11.4294C19.7985 12.2034 20.1118 12.7821 20.4421 13.1657C20.7758 13.5458 21.1419 13.7359 21.5403 13.7359C21.949 13.7359 22.1533 13.5339 22.1533 13.1297C22.1533 12.7976 22.0409 12.5099 21.8162 12.2667C21.5812 12.3181 21.319 12.3472 21.0295 12.3541L20.9734 11.2445C21.3377 11.2239 21.605 11.164 21.7753 11.0647C21.9456 10.9654 22.0307 10.801 22.0307 10.5715C22.0307 10.2291 21.8025 10.0578 21.3462 10.0578C20.9921 10.0578 20.5903 10.1726 20.1408 10.402L19.7526 9.34893Z' fill='%23F2F2F2'/%3E%3Cpath d='M18.9538 4.85567L16.3134 14.5479H15.078L17.7184 4.85567H18.9538Z' fill='%23F2F2F2'/%3E%3C/svg%3E%0A");
    content: '';
    background-repeat: no-repeat;
    background-size: 26px;
    background-position: center;
    width: 26px;
    height: 26px;
    display: inline-block;
  }

  /* Spinner fade */
  @keyframes vjs-spinner-fade {
    0% {
      border-top-color: #8d6dd6;
    }
    20% {
      border-top-color: #8d6dd6;
    }
    35% {
      border-top-color: #2928d4;
    }
    60% {
      border-top-color: #8d6dd6;
    }
    100% {
      border-top-color: #8d6dd6;
    }
  }
  .playerContainer {
    /* Kids safe blocker overlay */
    /* Mandatory and complete profile overlay */
  }

  .playerContainer .parentlockContainer {
    ${ZeeFontRegular(12, 16)}
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgb(0, 0, 0);
    z-index: 1;
  }
  .playerContainer .parentlockContainer .parentLock {
    background: rgb(255, 255, 255);
    padding: 16px;
    border-radius: 10px;
    max-width: 328px;
    min-height: 170px;
    margin: 0 auto;
    text-align: center;
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    background-color: #2e0130;
    box-sizing: border-box;
  }
  .playerContainer .parentlockContainer .parentLock .enterPinMsg {
    ${ZeeFontBold(16, 12.5)}
    color: rgb(255, 255, 255);
    margin: 10px 0 15px;
  }
  .playerContainer .parentlockContainer .parentLock .parentLockInput {
    ${ZeeFontBold(25, 16)}
    display: inline-block;
    margin: 0 5%;
    width: 15%;
    height: 45px;
    border-radius: 6px;
    border: 1px solid rgb(189, 189, 189);
    text-align: center;
    background-color: #9c9c9c;
    opacity: 0.4;
    box-sizing: border-box;
  }
  .playerContainer .parentlockContainer .parentLock .incorrectPinMsg {
    color: rgb(235, 87, 87);
    margin-top: 15px;
    display: none;
  }
  ${MQ.MediaLg} {
    .playerContainer .parentlockContainer .parentLock {
      max-width: 380px;
      min-height: 210px;
      padding: 30px 30px 40px;
    }
    .playerContainer .parentlockContainer .parentLock .enterPinMsg {
      ${SetFontSize(22, 28)}
    }
    .playerContainer .parentlockContainer .parentLock .parentLockInput {
      margin: 0 3.5%;
      width: 18%;
      height: 54px;
    }
  }
  .playerContainer .freeMinutesEndedPopup .skip-button {
    display: none;
  }
  .playerContainer .main-container {
    position: absolute;
    top: 0;
    right: 0;
    bottom: -1px;
    left: 0;
    background: rgb(0, 0, 0);
    z-index: 11;
    /* Tvod overly special handling */
  }
  .playerContainer .main-container .main-Inner-container,
  .playerContainer .main-container .adult-content-error-msg {
    margin: 0 auto;
    color: rgb(255, 255, 255);
    text-align: center;
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    padding: 0 40px;
    ${MQ.MediaMaxWidth480} {
      padding: 0 32px;
    }
    ${MQ.MediaSm} {
      padding: 0 62px;
    }
  }
  .playerContainer
    .main-container
    .adult-content-error-msg
    .multi-color-border {
    ${ZeeFontRegular(12, 12)}
    text-align: center;
    border-top: 5px solid;
    padding-bottom: 16px;
    border-image: linear-gradient(
        to right,
        #ffffff 14.28%,
        #f6b81a 14.28%,
        #f6b81a 28.56%,
        #21bbbf 28.56%,
        #21bbbf 42.86%,
        #7ead15 42.86%,
        #7ead15 57.14%,
        #b52c81 57.14%,
        #b52c81 71.42%,
        #b40329 71.42%,
        #b40329 85.7%,
        #0101ee 85.7%
      )
      7;
    margin: 0 auto;

    ${MQ.MediaMd} {
      max-width: 70%;
    }
  }
  .playerContainer .main-container .error-code {
    ${ZeeFontRegular(11, 18)}
    ${MQ.MediaSmMaxWidth} {
      bottom: 5%;
    }
    color: #828282;
    bottom: 10%;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
  .playerContainer .main-container .adult-content-error-msg .retry-btn {
    ${ZeeFontMedium(12, 18)};
    padding: 6px 16px;
    width: 165px;
    height: 32px;
    border: 1px solid ${colors.PrimaryWhiteColor};
    border-radius: 6px;
    cursor: pointer;
    margin: 0 auto;
    background: 0 0;
    color: inherit;
    appearance: none;
    ${MQ.MediaSm} {
      ${ZeeFontMedium(14, 22)};
      width: 220px;
      height: 38px;
      margin-top: 32px;
    }
  }
  .playerContainer
    .main-container
    .adult-content-error-msg
    .network-code-wrapper {
    display: block;
    margin-top: 16px;
    color: ${colors.AccentSubscriptionCodGrayColor};
    .icon {
      ${getOtherIcons(OtherIconsSet.INFO, false)}
      top: 2px;
      position: relative;
      ${ZeeFontRegular(14, 20)};
    }
    .network-code {
      margin-left: 8px;
      ${ZeeFontRegular(11, 18)};
      display: inline;
      cursor: pointer;
    }
  }
  .playerContainer .main-container .main-Inner-container .error-msg-title,
  .playerContainer .main-container .adult-content-error-msg .error-msg-title {
    ${ZeeFontBold(14)}
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: -0.43px;
    margin-top: 15px;
  }
  .playerContainer
    .main-container
    .main-Inner-container
    .adult-content-error-text,
  .playerContainer
    .main-container
    .adult-content-error-msg
    .adult-content-error-text {
    ${ZeeFontMedium(12, 16)}
    margin-bottom: 24px;
  }
  .playerContainer .main-container .main-Inner-container .login-text,
  .playerContainer .main-container .adult-content-error-msg .login-text {
    ${ZeeFontRegular(14, 14.285714286)}
    margin: 0 auto;
    width: fit-content;
    color: rgb(167, 133, 255);
    border-bottom: 1px dashed rgb(255, 255, 255);
    cursor: pointer;
  }
  .playerContainer .main-container .main-Inner-container .mandatory,
  .playerContainer .main-container .main-Inner-container .section-container,
  .playerContainer .main-container .adult-content-error-msg .mandatory,
  .playerContainer .main-container .adult-content-error-msg .section-container {
    position: relative;
  }
  .playerContainer
    .main-container
    .main-Inner-container
    .mandatory:last-child:before,
  .playerContainer
    .main-container
    .main-Inner-container
    .section-container:last-child:before,
  .playerContainer
    .main-container
    .adult-content-error-msg
    .mandatory:last-child:before,
  .playerContainer
    .main-container
    .adult-content-error-msg
    .section-container:last-child:before {
    content: '';
    width: 100%;
    display: block;
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0%,
      rgb(255, 255, 255) 49.36%,
      rgb(255, 255, 255) 50%,
      rgba(255, 255, 255, 0) 98.36%
    );
    height: 1px;
    margin: 10px 0;
  }
  .playerContainer
    .main-container
    .main-Inner-container
    .mandatory:first-of-type:before,
  .playerContainer
    .main-container
    .main-Inner-container
    .section-container:first-of-type:before,
  .playerContainer
    .main-container
    .adult-content-error-msg
    .mandatory:first-of-type:before,
  .playerContainer
    .main-container
    .adult-content-error-msg
    .section-container:first-of-type:before {
    display: none;
  }
  .playerContainer
    .main-container
    .main-Inner-container
    .mandatory
    .subscribe-msg-premium,
  .playerContainer
    .main-container
    .main-Inner-container
    .section-container
    .subscribe-msg-premium,
  .playerContainer
    .main-container
    .adult-content-error-msg
    .mandatory
    .subscribe-msg-premium,
  .playerContainer
    .main-container
    .adult-content-error-msg
    .section-container
    .subscribe-msg-premium {
    ${ZeeFontRegular(14, 14.285714286)}
    margin-bottom: 10px;
    color: rgb(255, 255, 255);
  }
  .playerContainer
    .main-container
    .main-Inner-container
    .mandatory
    .register-button,
  .playerContainer
    .main-container
    .main-Inner-container
    .mandatory
    .subscribe-button,
  .playerContainer
    .main-container
    .main-Inner-container
    .section-container
    .register-button,
  .playerContainer
    .main-container
    .main-Inner-container
    .section-container
    .subscribe-button,
  .playerContainer
    .main-container
    .adult-content-error-msg
    .mandatory
    .register-button,
  .playerContainer
    .main-container
    .adult-content-error-msg
    .mandatory
    .subscribe-button,
  .playerContainer
    .main-container
    .adult-content-error-msg
    .section-container
    .register-button,
  .playerContainer
    .main-container
    .adult-content-error-msg
    .section-container
    .subscribe-button {
    ${ZeeFontBold(12, 26.666666667)}
    display: inline-block;
    padding: 0 10px;
    color: rgb(130, 48, 198);
    background: rgb(255, 255, 255);
    border-radius: 4px;
    cursor: pointer;
  }
  .playerContainer
    .main-container
    .main-Inner-container
    .mandatory
    .buy-plan-btn,
  .playerContainer
    .main-container
    .main-Inner-container
    .section-container
    .buy-plan-btn,
  .playerContainer
    .main-container
    .adult-content-error-msg
    .mandatory
    .buy-plan-btn,
  .playerContainer
    .main-container
    .adult-content-error-msg
    .section-container
    .buy-plan-btn {
    background: rgb(130, 48, 198);
    color: rgb(255, 255, 255);
  }
  .playerContainer
    .main-container
    .main-Inner-container
    .mandatory
    .buy-plan-btn:before,
  .playerContainer
    .main-container
    .main-Inner-container
    .section-container
    .buy-plan-btn:before,
  .playerContainer
    .main-container
    .adult-content-error-msg
    .mandatory
    .buy-plan-btn:before,
  .playerContainer
    .main-container
    .adult-content-error-msg
    .section-container
    .buy-plan-btn:before {
    ${SetFontSize(14)}
    content: "P";
    font-family: '${IconsConstants.INITIAL_LOAD_ICONS}';
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    margin: 0 5px 0 0;
    position: relative;
    top: 1px;
  }

  .removePremiumIcon {
    &:before {
      display: none;
    }
  }
  .playerContainer
    .main-container
    .main-Inner-container
    .section-container
    .partnerAddOn {
    background: ${colors.PrimaryWhiteColor};
    color: ${colors.PrimaryBlackColor};
  }
  ${MQ.MediaLg} {
    .playerContainer
      .main-container
      .main-Inner-container
      .mandatory
      .buy-plan-btn:before,
    .playerContainer
      .main-container
      .main-Inner-container
      .section-container
      .buy-plan-btn:before,
    .playerContainer
      .main-container
      .adult-content-error-msg
      .mandatory
      .buy-plan-btn:before,
    .playerContainer
      .main-container
      .adult-content-error-msg
      .section-container
      .buy-plan-btn:before {
      ${SetFontSize(16)}
      margin-right: 6px;
      top: 2px;
    }
  }
  .playerContainer
    .main-container
    .main-Inner-container
    .mandatory
    .skip-button,
  .playerContainer
    .main-container
    .main-Inner-container
    .section-container
    .skip-button,
  .playerContainer
    .main-container
    .adult-content-error-msg
    .mandatory
    .skip-button,
  .playerContainer
    .main-container
    .adult-content-error-msg
    .section-container
    .skip-button {
    ${ZeeFontRegular(14, 14.285714286)}
    margin: 10px auto 0;
    width: fit-content;
    color: rgb(167, 133, 255);
    border-bottom: 1px dashed rgb(255, 255, 255);
    cursor: pointer;
  }
  .playerContainer .main-container .main-Inner-container .mandatory .login-msg,
  .playerContainer
    .main-container
    .main-Inner-container
    .mandatory
    .alreadyHave-msg,
  .playerContainer
    .main-container
    .main-Inner-container
    .section-container
    .login-msg,
  .playerContainer
    .main-container
    .main-Inner-container
    .section-container
    .alreadyHave-msg,
  .playerContainer
    .main-container
    .adult-content-error-msg
    .mandatory
    .login-msg,
  .playerContainer
    .main-container
    .adult-content-error-msg
    .mandatory
    .alreadyHave-msg,
  .playerContainer
    .main-container
    .adult-content-error-msg
    .section-container
    .login-msg,
  .playerContainer
    .main-container
    .adult-content-error-msg
    .section-container
    .alreadyHave-msg {
    ${ZeeFontRegular(14, 14.285714286)}
    color: rgb(255, 255, 255);
    margin-bottom: 10px;
  }
  .playerContainer
    .main-container
    .main-Inner-container
    .mandatory
    .login-link-wrap
    .userLogin-link,
  .playerContainer
    .main-container
    .main-Inner-container
    .mandatory
    .login-link-wrap
    .login-link,
  .playerContainer
    .main-container
    .main-Inner-container
    .section-container
    .login-link-wrap
    .userLogin-link,
  .playerContainer
    .main-container
    .main-Inner-container
    .section-container
    .login-link-wrap
    .login-link,
  .playerContainer
    .main-container
    .adult-content-error-msg
    .mandatory
    .login-link-wrap
    .userLogin-link,
  .playerContainer
    .main-container
    .adult-content-error-msg
    .mandatory
    .login-link-wrap
    .login-link,
  .playerContainer
    .main-container
    .adult-content-error-msg
    .section-container
    .login-link-wrap
    .userLogin-link,
  .playerContainer
    .main-container
    .adult-content-error-msg
    .section-container
    .login-link-wrap
    .login-link {
    ${ZeeFontRegular(14, 14.285714286)}
    margin: 0 auto;
    width: fit-content;
    color: rgb(167, 133, 255);
    border-bottom: 1px dashed rgb(255, 255, 255);
    cursor: pointer;
  }
  ${MQ.MediaSm} {
    .playerContainer .main-container .main-Inner-container,
    .playerContainer .main-container .adult-content-error-msg {
      max-width: 85%;
    }
    .playerContainer
      .main-container
      .main-Inner-container
      .adult-content-error-text,
    .playerContainer
      .main-container
      .adult-content-error-msg
      .adult-content-error-text {
      margin-bottom: 24px;
    }
    .playerContainer .main-container .main-Inner-container .error-msg-title,
    .playerContainer .main-container .adult-content-error-msg .error-msg-title {
      font-size: 18px;
    }
    .playerContainer .main-container .main-Inner-container .mandatory,
    .playerContainer .main-container .main-Inner-container .section-container,
    .playerContainer .main-container .adult-content-error-msg .mandatory,
    .playerContainer
      .main-container
      .adult-content-error-msg
      .section-container {
      position: relative;
    }
    .playerContainer
      .main-container
      .main-Inner-container
      .mandatory:last-child:before,
    .playerContainer
      .main-container
      .main-Inner-container
      .section-container:last-child:before,
    .playerContainer
      .main-container
      .adult-content-error-msg
      .mandatory:last-child:before,
    .playerContainer
      .main-container
      .adult-content-error-msg
      .section-container:last-child:before {
      margin: 25px 0;
    }
    .playerContainer
      .main-container
      .main-Inner-container
      .mandatory
      .skip-button,
    .playerContainer
      .main-container
      .main-Inner-container
      .section-container
      .skip-button,
    .playerContainer
      .main-container
      .adult-content-error-msg
      .mandatory
      .skip-button,
    .playerContainer
      .main-container
      .adult-content-error-msg
      .section-container
      .skip-button {
      margin-top: 15px;
    }
    .playerContainer
      .main-container
      .main-Inner-container
      .mandatory
      .subscribe-msg-premium,
    .playerContainer
      .main-container
      .main-Inner-container
      .mandatory
      .login-msg,
    .playerContainer
      .main-container
      .main-Inner-container
      .mandatory
      .alreadyHave-msg,
    .playerContainer
      .main-container
      .main-Inner-container
      .section-container
      .subscribe-msg-premium,
    .playerContainer
      .main-container
      .main-Inner-container
      .section-container
      .login-msg,
    .playerContainer
      .main-container
      .main-Inner-container
      .section-container
      .alreadyHave-msg,
    .playerContainer
      .main-container
      .adult-content-error-msg
      .mandatory
      .subscribe-msg-premium,
    .playerContainer
      .main-container
      .adult-content-error-msg
      .mandatory
      .login-msg,
    .playerContainer
      .main-container
      .adult-content-error-msg
      .mandatory
      .alreadyHave-msg,
    .playerContainer
      .main-container
      .adult-content-error-msg
      .section-container
      .subscribe-msg-premium,
    .playerContainer
      .main-container
      .adult-content-error-msg
      .section-container
      .login-msg,
    .playerContainer
      .main-container
      .adult-content-error-msg
      .section-container
      .alreadyHave-msg {
      margin-bottom: 20px;
    }
  }
  ${MQ.MediaMd} {
    .playerContainer
      .main-container
      .main-Inner-container
      .adult-content-error-text,
    .playerContainer .main-container .main-Inner-container .login-text,
    .playerContainer
      .main-container
      .adult-content-error-msg
      .adult-content-error-text,
    .playerContainer .main-container .adult-content-error-msg .login-text {
      ${ZeeFontMedium(14, 20)}
    }
    .playerContainer
      .main-container
      .main-Inner-container
      .mandatory:last-child:before,
    .playerContainer
      .main-container
      .main-Inner-container
      .section-container:last-child:before,
    .playerContainer
      .main-container
      .adult-content-error-msg
      .mandatory:last-child:before,
    .playerContainer
      .main-container
      .adult-content-error-msg
      .section-container:last-child:before {
      margin: 35px 0;
    }
    .playerContainer
      .main-container
      .main-Inner-container
      .mandatory
      .register-button,
    .playerContainer
      .main-container
      .main-Inner-container
      .mandatory
      .subscribe-button,
    .playerContainer
      .main-container
      .main-Inner-container
      .section-container
      .register-button,
    .playerContainer
      .main-container
      .main-Inner-container
      .section-container
      .subscribe-button,
    .playerContainer
      .main-container
      .adult-content-error-msg
      .mandatory
      .register-button,
    .playerContainer
      .main-container
      .adult-content-error-msg
      .mandatory
      .subscribe-button,
    .playerContainer
      .main-container
      .adult-content-error-msg
      .section-container
      .register-button,
    .playerContainer
      .main-container
      .adult-content-error-msg
      .section-container
      .subscribe-button {
      ${SetFontSize(14, 36)}
      border-radius: 6px;
      padding: 0 16px;
    }
    .playerContainer
      .main-container
      .main-Inner-container
      .mandatory
      .skip-button,
    .playerContainer
      .main-container
      .main-Inner-container
      .section-container
      .skip-button,
    .playerContainer
      .main-container
      .adult-content-error-msg
      .mandatory
      .skip-button,
    .playerContainer
      .main-container
      .adult-content-error-msg
      .section-container
      .skip-button {
      ${SetFontSize(16, 22)}
    }
    .playerContainer
      .main-container
      .main-Inner-container
      .mandatory
      .subscribe-msg-premium,
    .playerContainer
      .main-container
      .main-Inner-container
      .mandatory
      .login-msg,
    .playerContainer
      .main-container
      .main-Inner-container
      .mandatory
      .alreadyHave-msg,
    .playerContainer
      .main-container
      .main-Inner-container
      .section-container
      .subscribe-msg-premium,
    .playerContainer
      .main-container
      .main-Inner-container
      .section-container
      .login-msg,
    .playerContainer
      .main-container
      .main-Inner-container
      .section-container
      .alreadyHave-msg,
    .playerContainer
      .main-container
      .adult-content-error-msg
      .mandatory
      .subscribe-msg-premium,
    .playerContainer
      .main-container
      .adult-content-error-msg
      .mandatory
      .login-msg,
    .playerContainer
      .main-container
      .adult-content-error-msg
      .mandatory
      .alreadyHave-msg,
    .playerContainer
      .main-container
      .adult-content-error-msg
      .section-container
      .subscribe-msg-premium,
    .playerContainer
      .main-container
      .adult-content-error-msg
      .section-container
      .login-msg,
    .playerContainer
      .main-container
      .adult-content-error-msg
      .section-container
      .alreadyHave-msg {
      ${SetFontSize(16, 22)}
    }
    .playerContainer
      .main-container
      .main-Inner-container
      .mandatory
      .login-link-wrap
      .userLogin-link,
    .playerContainer
      .main-container
      .main-Inner-container
      .mandatory
      .login-link-wrap
      .login-link,
    .playerContainer
      .main-container
      .main-Inner-container
      .section-container
      .login-link-wrap
      .userLogin-link,
    .playerContainer
      .main-container
      .main-Inner-container
      .section-container
      .login-link-wrap
      .login-link,
    .playerContainer
      .main-container
      .adult-content-error-msg
      .mandatory
      .login-link-wrap
      .userLogin-link,
    .playerContainer
      .main-container
      .adult-content-error-msg
      .mandatory
      .login-link-wrap
      .login-link,
    .playerContainer
      .main-container
      .adult-content-error-msg
      .section-container
      .login-link-wrap
      .userLogin-link,
    .playerContainer
      .main-container
      .adult-content-error-msg
      .section-container
      .login-link-wrap
      .login-link {
      ${SetFontSize(16, 22)}
    }
  }
  ${MQ.MediaXl} {
    .playerContainer .main-container .main-Inner-container,
    .playerContainer .main-container .adult-content-error-msg {
      padding: 0% 15%;
    }
    .playerContainer
      .main-container
      .main-Inner-container
      .adult-content-error-text,
    .playerContainer
      .main-container
      .adult-content-error-msg
      .adult-content-error-text {
      margin-bottom: 25px;
    }
    .playerContainer
      .main-container
      .main-Inner-container
      .mandatory:last-child:before,
    .playerContainer
      .main-container
      .main-Inner-container
      .section-container:last-child:before,
    .playerContainer
      .main-container
      .adult-content-error-msg
      .mandatory:last-child:before,
    .playerContainer
      .main-container
      .adult-content-error-msg
      .section-container:last-child:before {
      margin: 45px 0;
    }
    .playerContainer
      .main-container
      .main-Inner-container
      .mandatory
      .skip-button,
    .playerContainer
      .main-container
      .main-Inner-container
      .section-container
      .skip-button,
    .playerContainer
      .main-container
      .adult-content-error-msg
      .mandatory
      .skip-button,
    .playerContainer
      .main-container
      .adult-content-error-msg
      .section-container
      .skip-button {
      margin-top: 25px;
    }
    .playerContainer
      .main-container
      .main-Inner-container
      .mandatory
      .subscribe-msg-premium,
    .playerContainer
      .main-container
      .main-Inner-container
      .mandatory
      .login-msg,
    .playerContainer
      .main-container
      .main-Inner-container
      .mandatory
      .alreadyHave-msg,
    .playerContainer
      .main-container
      .main-Inner-container
      .section-container
      .subscribe-msg-premium,
    .playerContainer
      .main-container
      .main-Inner-container
      .section-container
      .login-msg,
    .playerContainer
      .main-container
      .main-Inner-container
      .section-container
      .alreadyHave-msg,
    .playerContainer
      .main-container
      .adult-content-error-msg
      .mandatory
      .subscribe-msg-premium,
    .playerContainer
      .main-container
      .adult-content-error-msg
      .mandatory
      .login-msg,
    .playerContainer
      .main-container
      .adult-content-error-msg
      .mandatory
      .alreadyHave-msg,
    .playerContainer
      .main-container
      .adult-content-error-msg
      .section-container
      .subscribe-msg-premium,
    .playerContainer
      .main-container
      .adult-content-error-msg
      .section-container
      .login-msg,
    .playerContainer
      .main-container
      .adult-content-error-msg
      .section-container
      .alreadyHave-msg {
      margin-bottom: 25px;
    }
  }
  .playerContainer .main-container.tvodOverlay {
    background: rgb(64, 26, 76);
  }
  .playerContainer .main-container.tvodOverlay .zeeplex-Logo-container {
    width: 63px;
    height: 32px;
    background: url('/webapp-assets/images/zee-plex-logo.png') no-repeat center;
    background-size: 100%;
    margin: 0 auto 10px;
  }
  ${MQ.MediaSm} {
    .playerContainer .main-container.tvodOverlay .zeeplex-Logo-container {
      margin-bottom: 20px;
    }
  }
  ${MQ.MediaLg} {
    .playerContainer .main-container.tvodOverlay .zeeplex-Logo-container {
      width: 95px;
      height: 48px;
    }
  }
  ${MQ.MediaXl} {
    .playerContainer .main-container.tvodOverlay .zeeplex-Logo-container {
      margin-bottom: 25px;
    }
  }
  .playerContainer
    .main-container.tvodOverlay
    .zeeplex-Logo-container
    + .section-container:last-child:before {
    display: none;
  }
  .playerContainer
    .main-container.tvodOverlay
    .main-Inner-container
    .section-container
    .subscribe-button {
    background: rgb(130, 48, 198);
    color: rgb(255, 255, 255);
  }
  @media screen and (max-width: 400px) {
    .playerContainer .main-container.tvodOverlay .zeeplex-Logo-container {
      margin-bottom: 6px;
    }
    .playerContainer
      .main-container.tvodOverlay
      .main-Inner-container
      .section-container:before {
      margin: 6px 0;
    }
    .playerContainer
      .main-container.tvodOverlay
      .main-Inner-container
      .section-container
      .subscribe-msg-premium,
    .playerContainer
      .main-container.tvodOverlay
      .main-Inner-container
      .section-container
      .alreadyHave-msg {
      margin-bottom: 6px;
    }
    .playerContainer
      .main-container.tvodOverlay
      .main-Inner-container
      .section-container
      .skip-button {
      margin-top: 6px;
    }
  }
  .playerContainer .main-container .lottie-position {
    width: 100%;
    height: 100%;
    position: absolute;
  }
  .playerContainer .main-container.subscription-nudge-container {
    background-color: rgb(29, 20, 37);
  }
  .playerContainer
    .main-container.subscription-nudge-container
    .main-Inner-container {
    position: absolute;
    display: block;
    padding: 0;
    text-align: start;
    right: 20px;
    width: 204px;
  }
  ${MQ.MediaSm} {
    .playerContainer
      .main-container.subscription-nudge-container
      .main-Inner-container {
      right: 60px;
    }
  }
  ${MQ.MediaMd} {
    .playerContainer
      .main-container.subscription-nudge-container
      .main-Inner-container {
      right: 160px;
    }
  }
  ${MQ.MediaLg} {
    .playerContainer
      .main-container.subscription-nudge-container
      .main-Inner-container {
      right: 43px;
      width: 232px;
    }
  }
  ${MQ.MediaXl} {
    .playerContainer
      .main-container.subscription-nudge-container
      .main-Inner-container {
      right: 160px;
    }
  }
  .playerContainer
    .main-container.subscription-nudge-container
    .main-Inner-container
    .subscription-msg-avod {
    ${ZeeFontRegular(12, 13.333333333)}
    margin-bottom: 8px;
    color: rgb(255, 255, 255);
  }
  ${MQ.MediaLg} {
    .playerContainer
      .main-container.subscription-nudge-container
      .main-Inner-container
      .subscription-msg-avod {
      ${ZeeFontMedium(16, 22)}
      margin-bottom: 12px;
    }
  }
  .playerContainer
    .main-container.subscription-nudge-container
    .main-Inner-container
    .subscribe-button {
    display: inline-block;
    ${ZeeFontBold(12, 13.33333333)}
    padding: 8px 12px;
    color: rgb(130, 48, 198);
    background: rgb(255, 255, 255);
    border-radius: 4px;
    cursor: pointer;
    text-transform: uppercase;
  }
  ${MQ.MediaLg} {
    .playerContainer
      .main-container.subscription-nudge-container
      .main-Inner-container
      .subscribe-button {
      ${ZeeFontBold(14, 14.285724286)}
      padding: 12px 26px;
    }
  }
  .playerContainer
    .main-container.subscription-nudge-container
    .main-Inner-container
    .buy-plan-btn {
    background: rgb(130, 48, 198);
    color: rgb(255, 255, 255);
  }
  .playerContainer
    .main-container.subscription-nudge-container
    .main-Inner-container
    .buy-plan-btn:before {
    content: 'P';
    font-family: '${IconsConstants.INITIAL_LOAD_ICONS}';
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    margin: 0 5px 0 0;
    font-size: 1.4rem;
    position: relative;
    top: 1px;
  }
  ${MQ.MediaLg} {
    .playerContainer
      .main-container.subscription-nudge-container
      .main-Inner-container
      .buy-plan-btn:before {
      font-size: 1rem;
      margin-right: 6px;
      top: 2px;
    }
  }
  .playerContainer
    .main-container.subscription-nudge-container
    .main-Inner-container
    .continue-watching-btn {
    display: inline-block;
    position: relative;
    border: 1px solid rgb(255, 255, 255);
    ${ZeeFontBold(12, 13.3333333)}
    padding: 8px 12px;
    color: rgb(255, 255, 255);
    border-radius: 4px;
    cursor: pointer;
    text-transform: uppercase;
    margin-top: 16px;
  }
  ${MQ.MediaLg} {
    .playerContainer
      .main-container.subscription-nudge-container
      .main-Inner-container
      .continue-watching-btn {
      ${ZeeFontBold(14, 14.285)}
      padding: 14px 11px;
      margin-top: 32px;
      border-radius: 6px;
    }
  }
  .playerContainer
    .main-container.subscription-nudge-container
    .main-Inner-container
    .continue-watching-btn
    .continue-watching-btn-white {
    position: absolute;
    background: rgb(255, 255, 255);
    color: rgb(0, 0, 0);
    top: 0;
    left: 0;
    bottom: 0;
    padding: 8px 0px;
    text-indent: 12px;
    width: 0%;
    overflow: hidden;
    border-radius: 4px;
    white-space: nowrap;
  }
  ${MQ.MediaLg} {
    .playerContainer
      .main-container.subscription-nudge-container
      .main-Inner-container
      .continue-watching-btn
      .continue-watching-btn-white {
      ${ZeeFontBold(14, 14.285714286)}
      padding: 14px 0px;
      text-indent: 11px;
      border-radius: 6px;
    }
  }
  .playerContainer .getApp {
    margin: 20px;
  }

  .main-container.freeMinutesEndedPopup
    .main-Inner-container
    .subscribe-msg-premium-sub {
    margin-bottom: 20px;
    margin-top: -10px;
  }

  .main-container.container-transparent {
    background: transparent;
    pointer-events: none;
  }
  .main-container.container-transparent * {
    pointer-events: all;
  }

  /* Player placeholder aspect ratio which includes content div also */
  .playerPlaceholderAr {
    position: relative;
    z-index: 2;
  }
  .playerPlaceholderAr:before {
    display: block;
    content: ' ';
    width: 100%;
    padding-top: 56.25%;
  }
  .playerPlaceholderAr > .content {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  @media screen and (max-width: 1199px) and (orientation: portrait) {
    .playerPlaceholderAr.teaserHeight {
      margin-bottom: 48px;
    }
    .playerPlaceholderAr .playerContentWrapper {
      position: fixed;
      top: 65px;
      bottom: auto;
    }
  }
  @media screen and (max-width: 599px) and (orientation: portrait) {
    .playerPlaceholderAr .playerContentWrapper {
      top: 44px;
    }
  }
  ${MQ.MediaLg} {
    .playerPlaceholderAr.teaserHeight {
      margin-bottom: 65px;
    }
  }

  /* Top banner */
  @media screen and (max-width: 1199px) and (orientation: portrait) {
    #af-smart-banner ~ #root .playerPlaceholderAr .playerContentWrapper {
      top: 135px;
    }
  }
  @media screen and (max-width: 599px) and (orientation: portrait) {
    #af-smart-banner ~ #root .playerPlaceholderAr .playerContentWrapper {
      top: 114px;
    }
  }

  /* Player component will start here */
  .playerContainer {
    position: relative;
  }
  .playerContainer:before {
    display: block;
    content: ' ';
    width: 100%;
    padding-top: 56.25%;
  }
  .playerContainer > .content {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  .playerContainer:before {
    background-size: auto 50%;
    background-image: url('/webapp-assets/images/placeholder_zee5.svg');
    background-repeat: no-repeat;
    background-position: center;
    background-color: rgb(26, 12, 39);
  }
  .playerContainer > .content {
    width: 100%;
    height: 100%;
  }
  .playerContainer video.playerComp {
    display: none;
  }

  .customPlayerContainer .playerComp .vjs-control-bar {
    width: 62.5%;
  }

  .customPlayerContainer .playerComp .vjs-skip-wrapper {
    left: 10%;
    right: 54%;
  }

  .customPlayerContainer .playerComp .vjs-tech {
    width: 64%;
  }

  .chromeCastBtnContainer {
    margin-top: 10px;
    right: 2%;
    background: transparent;
    cursor: pointer;
    z-index: 1;
    height: 24px;
    width: 30px;
    &.adjustChromeCastIconContainer {
      margin-right: 38%;
    }
  }

  .audio-selection-wrapper {
    position: absolute;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    flex-direction: column;
    height: 100%;
    background: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.8) 100%
    );
    transform: matrix(1, 0, 0, 1, 0, 0);
    top: 0%;
  }

  .audio-selection-list {
    display: flex;
    flex-direction: row;
  }

  .audio-stream-item {
    cursor: pointer;
    padding: 10px 12px 6px;
    ${ZeeFontBold(12, 13.3333333)}
    width: 75px;
    height: 36px;
    color: #ffffff;
    font-weight: 500;
    background: rgba(255, 255, 255, 0.15);
    border: 1px solid #ffffff;
    border-radius: 99px;
    margin-right: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row-reverse;
  }
  ${MQ.MediaSm} {
    .audio-stream-item {
      ${ZeeFontBold(14, 14.285714286)}
      font-weight: 500;
      width: 120px;
      height: 38px;
    }
  }
  ${MQ.MediaMd} {
    .audio-stream-item {
      ${ZeeFontBold(14, 14.285714286)}
      font-weight: 500;
      width: 120px;
      height: 38px;
    }
  }
  ${MQ.MediaXl} {
    .audio-stream-item {
      ${ZeeFontBold(18, 14.4444444)}
      font-weight: 500;
      width: 120px;
      height: 38px;
    }
  }

  .audio-selection-title {
    margin-top: 21px;
    ${ZeeFontBold(14, 14.285714286)}
    text-align: center;
    color: #ffffff;
    margin-bottom: 12px;
  }
  ${MQ.MediaSm} {
    .audio-selection-title {
      ${ZeeFontBold(16, 13.75)}
      margin-top: 28px;
    }
  }
  ${MQ.MediaMd} {
    .audio-selection-title {
      ${ZeeFontBold(18, 13.333333)}
      margin-top: 32px;
    }
  }
  ${MQ.MediaXl} {
    .audio-selection-title {
      ${ZeeFontBold(28, 15)}
      margin-top: 32px;
    }
  }

  .activeAudioLang {
    font-weight: 700;
    padding: 8px 16px;
  }
  .activeAudioLang > span {
    margin-right: 9px;
  }

  .vjs-menu li {
    text-transform: none;
  }

  .figureTeaserBannerWrapper {
    z-index: 2;
    .teaserWrapperAdded {
      margin-bottom: 48px;
    }
  }


.playerContainer .main-container .main-Inner-container .mandatory .buy-plan-btn:before, .playerContainer .main-container .main-Inner-container .section-container .buy-plan-btn:before, .playerContainer .main-container .adult-content-error-msg .mandatory .buy-plan-btn:before, .playerContainer .main-container .adult-content-error-msg .section-container .buy-plan-btn:before{
  font-family: var(--font-initial-load-icons);
}
`;

export const playerBot = css`
  position: relative;
  width: 100%;
  height: 100%;
`;
